<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70" />
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-row>
          <b-col md="10">
            <b-navbar class="formCard" style="
                border-radius: 5px !important;
                padding-left: 0px;
                height: auto !important;
              " toggleable="lg" type="dark" variant="primary">
              <b-navbar-nav>
                <b-button @click="previousSalesView" size="sm" variant="light">
                  <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
                </b-button>
              </b-navbar-nav>
              <b-navbar-brand center class="mobile-font">Shipping Line Payment(Invoice wise)
                {{ ffExportDetail.allModuleId }}</b-navbar-brand>
            </b-navbar>
          </b-col>

          <b-col md="2">
            <RemoveSlineInvoiceButton v-if="ffExportDetail.allModuleId && SBDetail.ffSlinePayId" :Type="'All'"
              :BTNTitle="''" :SlineType="'FFSline'" :TransportType="'Export'" :SlinePayId="SBDetail.ffSlinePayId"
              :SlineInvId="''" :allModuleId="ffExportDetail.allModuleId" @refresh-data="refreshData" />
          </b-col>

        </b-row>

        <banner-component v-if="ffExportDetail.allModuleId" :allModuleIdBanner="ffExportDetail.allModuleId ? ffExportDetail.allModuleId : ''
          " :jobSeriesBanner="ffExportDetail.ffExportFclSeries ? ffExportDetail.ffExportFclSeries : ''
            " :bannerClientName="ffExportDetail.clientName ? ffExportDetail.clientName : ''" iconId="fa fa-ship" />
        <b-card class="formCard">
          <b-card-text>
            <div>
              <!-- *******************************  Start  WareHouse  Warehouse Stuffing At ICD *****************************-->
              <div class="mt-2" v-if="containerTypeDetailFactoryList.length > 0">
                <h5>
                  <b-badge>Container Details</b-badge>
                </h5>
                <div>
                  <b-button v-if="
                    ContainerTypeSizefactory.ffExecutionContainerId != '' &&
                    showMoreSB == false
                  " size="sm" variant="outline-dark" @click="showMoreSBDet">{{ showMoreSB == true ? "Show" : "Hide "
                    }} Container
                    Details</b-button>
                </div>
                <b-card class="mt-3" v-if="
                  (getContainerList.length > 0 ||
                    ContainerTypeSizefactory.ffExecutionContainerId != '') &&
                  showMoreSB == false
                " style="background: whiteSmoke">
                  <div class="gutr" v-if="
                    getContainerList.length > 0 ||
                    ContainerTypeSizefactory.ffExecutionContainerId != ''
                  ">
                    <div v-if="showMoreSB == false">
                      <md-layout md-gutter class="labelMargtop">
                        <md-layout md-flex="50">
                          <label v-if="ContainerTypeSizefactory.ffExecutionContainerId == ''">Container
                            Type/Size</label>
                          <model-list-select v-if="ContainerTypeSizefactory.ffExecutionContainerId == ''"
                            option-value="containerTypeId" option-text="containerType" :list="ContainerTypeList"
                            placeholder="Select  Type/Size"
                            v-model="ContainerTypeSizefactory.containerTypeId"></model-list-select>
                          <md-layout md-flex="100" v-else>
                            <label for="containerType">Container Type/Size</label>
                            <b-form-input :formatter="capitalizeAll" v-model="ContainerTypeSizefactory.containerType"
                              disabled></b-form-input>
                          </md-layout>
                          <span class="error" v-if="!ContainerTypeSizefactory.containerTypeId">{{
                            errorContainer.containerTypeId }}</span>
                        </md-layout>

                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="45">
                          <md-layout md-flex="100">
                            <label>Container No.(eg. AAAA1234567)</label>
                            <b-form-input :formatter="capitalizeAll" name="containerNo"
                              v-model="ContainerTypeSizefactory.containerNo"
                              @keyup="containerNoRegexfun"></b-form-input>
                          </md-layout>
                          <span class="error" v-if="!ContainerTypeSizefactory.containerNo">{{ errorContainer.containerNo
                            }}</span>
                          <span class="error" v-else-if="containerNoRegexError != ''">{{
                            containerNoRegexError
                          }}</span>
                          <span class="error" v-if="
                            containerNoRegexError == '' &&
                            ContainerTypeSizefactory.containerNo != '' &&
                            ContainerTypeSizefactory.containerNo != algoConNo &&
                            showAlgo == true
                          ">Note:System Generated Container No. is :
                            {{ algoConNo }}</span>
                        </md-layout>
                      </md-layout>
                      <md-layout md-gutter class="labelMargtop">
                        <md-layout md-flex="55"></md-layout>
                        <md-layout md-flex="10">
                          <md-layout md-flex="100">
                            <label>Net Wgt.</label>
                            <b-form-input :formatter="capitalizeAll" id="netWeight" name="netWeight" type="number"
                              min="0" v-model="ContainerTypeSizefactory.netWeight"></b-form-input>
                          </md-layout>
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="10">
                          <md-layout md-flex="100">
                            <label>Gross Wgt</label>
                            <b-form-input :formatter="capitalizeAll" id="grossWeight" name="grossWeight" type="number"
                              min="0" v-model="ContainerTypeSizefactory.grossWeight"></b-form-input>
                          </md-layout>

                          <span class="error" v-if="!ContainerTypeSizefactory.grossWeight">{{ errorContainer.grossWeight
                            }}</span>
                        </md-layout>

                        <md-layout md-flex="5"></md-layout>

                        <md-layout md-flex="15">
                          <label for="weightUnit">Unit</label>
                          <model-list-select :list="unitList" option-value="uV" option-text="uT"
                            placeholder="Select Unit" name="weightUnit" id="weightUnit"
                            v-model="ContainerTypeSizefactory.weightUnit"></model-list-select>
                        </md-layout>
                      </md-layout>

                      <md-layout md-gutter class="labelMargtop">
                        <md-layout md-flex="15">
                          <label>Handover Date</label>
                          <date-picker :format="selectDateFormat" lang="en" :minute-step="1" name="handoverDate"
                            id="handoverDate" v-model="ContainerTypeSizefactory.handoverDate"></date-picker>
                        </md-layout>

                        <md-layout md-flex="5"></md-layout>

                        <md-layout md-flex="25">
                          <md-layout md-flex="100">
                            <label>Custom Seal No.</label>
                            <b-form-input :formatter="capitalizeAll" id="customSealNo" name="customSealNo"
                              v-model="ContainerTypeSizefactory.customSealNo"></b-form-input>
                          </md-layout>
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="25">
                          <md-layout md-flex="100">
                            <label>Line Seal No.</label>
                            <b-form-input :formatter="capitalizeAll" id="LineSealNo" name="LineSealNo"
                              v-model="ContainerTypeSizefactory.LineSealNo"></b-form-input>
                          </md-layout>
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="20">
                          <md-layout md-flex="100">
                            <label>Container Tare Wgt</label>
                            <b-form-input :formatter="capitalizeAll" id="tareWeight" name="tareWeight" type="number"
                              min="0" v-model="ContainerTypeSizefactory.tareWeight"></b-form-input>
                          </md-layout>
                        </md-layout>
                      </md-layout>

                      <md-layout md-gutter class="labelMargtop">
                        <md-layout md-flex="20">
                          <md-layout md-flex="100">
                            <label>Measurement (in CBM)</label>
                            <b-form-input :formatter="capitalizeAll" name="noOfpkgUnit" id="noOfpkgUnit" type="number"
                              min="0" v-model="ContainerTypeSizefactory.measurement"></b-form-input>
                            
                          </md-layout>
                        </md-layout>

                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="20">
                          <label>Package Details</label>
                          <model-list-select :list="packageNameList" id="clientId"
                            v-model="ContainerTypeSizefactory.packageId" option-value="packageId"
                            option-text="packageName" placeholder="Select  Package Name"></model-list-select>

                          <span class="error" v-if="!ContainerTypeSizefactory.packageId">{{ errorContainer.packageId
                            }}</span>
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="50">
                          <md-layout md-flex="100">
                            <label>No. of Packages ({{
                              ContainerTypeSizefactory.packageName
                            }})</label>
                            <b-form-input :formatter="capitalizeAll" name="noOfpkgUnit" id="noOfpkgUnit" type="number"
                              min="0" :disabled="ContainerTypeSizefactory.packageName == '' ? true : false
                                " v-model="ContainerTypeSizefactory.noOfpkgUnit"></b-form-input>
                            <span class="error" v-if="!ContainerTypeSizefactory.noOfpkgUnit">{{
                              errorContainer.noOfpkgUnit }}</span>
                          </md-layout>
                        </md-layout>
                      </md-layout>

                      <md-layout md-gutter class="labelMargtop">
                        <md-layout md-flex="20">
                          <label>Cargo Stuffing Date</label>
                          <date-picker :format="selectDateFormat" lang="en" name="cargoStuffingDate"
                            id="cargoStuffingDate" v-model="ContainerTypeSizefactory.cargoStuffingDate"
                            :minute-step="1"></date-picker>
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="20">
                          <label>LEEO (Let Export Permit) Date</label>
                          <date-picker :format="selectDateFormat" lang="en" name="leeoDate" id="leeoDate"
                            v-model="ContainerTypeSizefactory.leeoDate" :minute-step="1"></date-picker>
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="50">
                          <md-layout md-flex="100">
                            <label>LEEO (Let Export Permit) No.</label>
                            <b-form-input :formatter="capitalizeAll" name="leeoNo" id="leeoNo"
                              v-model="ContainerTypeSizefactory.leeoNo"></b-form-input>
                          </md-layout>
                        </md-layout>
                      </md-layout>
                    </div>
                  </div>
                </b-card>

                <div class="box-body mt-2">
                  <table id="ffContainer" class="table table-bordered">
                    <thead>
                      <tr>
                        <th>SN.</th>

                        <th>Container No.</th>

                        <th>Container Type</th>
                        <th>Custom Seal No.</th>
                        <th>Line Seal No.</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in containerTypeDetailFactoryList" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td @click="viewEdit(item.ffExecutionContainerId, index)" class="showMoreData">
                          {{ item.containerNo }}
                        </td>
                        <td @click="viewEdit(item.ffExecutionContainerId, index)" class="showMoreData">
                          {{ item.containerType }}
                        </td>

                        <td>
                          {{ item.customSealNo != "" ? item.customSealNo : "--" }}
                        </td>
                        <td>
                          {{ item.LineSealNo != "" ? item.LineSealNo : "--" }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
             
              <b-row>
                <b-col md="12" v-if="
                  (SBDetail.ffSlinePayId != '' && accounts == false) ||
                  (SBDetail.ffSlinePayId != '' && role == 'Admin')
                ">
                  <b-form-checkbox id="checkbox-1" v-model="SBDetail.revisedMail" name="checkbox-1" value="1"
                    unchecked-value="0">
                  </b-form-checkbox><span class="error">Send Revised Payment Request</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <label>Pay To <span class="error">*</span></label>
                  <model-list-select
                    :list="payToOptions"
                    v-model="SBDetail.pay_to"
                    option-value="payVal"
                    option-text="payText"
                    placeholder="Select Payment Flow"
                    
                  ></model-list-select>
                  <span class="error" v-if="SBDetail.pay_to_err ? true : false">{{ SBDetail.pay_to_err }}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <label>POD<span class="error">*</span></label>
                  <b-form-input :formatter="capitalizeAll" disabled name="POD" id="POD" v-model="POD"></b-form-input>
                  <span class="error" v-if="POD_err ? true : false">{{ POD_err }}</span>
                </b-col>
                <b-col md="3">
                  <label>B/L No.<span class="error">*</span></label>
                  <b-form-input :formatter="capitalizeAll" :disabled="(accounts == true && role != 'Admin') || SBDetail.ffSlinePayId != ''
                    ? true
                    : false
                    " name="POD" id="POD" v-model="SBDetail.SlineBlNo"></b-form-input>
                  <span class="error" v-if="SBDetail.SlineBlNo_err ? true : false">{{
                    SBDetail.SlineBlNo_err
                  }}</span>
                </b-col>
                <b-col md="3" v-if="oceanFreightDetails.length > 0">
                  <label>OCEAN FREIGHT Booking-Console.</label>
                  <table border="1" style="width: 100%">
                    <thead>
                      <tr>
                        <th><center>CONTAINER TYPE</center></th>
                        <th><center>BUYING OCEAN FREIGHT</center></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in oceanFreightDetails" :key="index">
                        <td><b><center>{{ item.cont_type }}</center></b></td>
                        <td><b><center>{{ item.buying_ocean_freight + " " + item.currencyName }}</center></b></td>
                      </tr>
                    </tbody>
                  </table>
                </b-col>
                <b-col md="2">
                  <span>Added By :<span style="font-weight: bold; color: red">{{
                    ffExportDetail.username
                  }}</span>
                    on
                    <span style="font-weight: bold; color: red">{{
                      ffExportDetail.creationTime
                    }}</span></span>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <label>Shipping Line<span class="error">*</span> </label>
                  <b-form-input :formatter="capitalizeAll" disabled name="POD" id="POD"
                    v-model="ffExportDetail.shippingLine" />
                  <span class="error" v-if="ffExportDetail.shippingLine_err ? true : false">{{
                    ffExportDetail.shippingLine_err }}</span>
                </b-col>
                <b-col md="3">
                  <label>Shipping Line Confirmation <span class="error">*</span></label>
                  <model-list-select 
                    :list="ffExportDetail.containerInfo == 'lcl'
                      ? $store.getters['common/getAllColoaderList']
                      : $store.getters['common/getAllShippingLineList']
                      " v-model="ffExportDetail.shippingID" :isDisabled="SBDetail.ffSlinePayId != '' && ffExportDetail.shippingID != ''
                        ? true
                        : false
                        " :option-value="'shippingId'" :option-text="'shippingLine'" id="shippingID"
                    placeholder="Select Shipping Line" @input="
                      CheckShippingLine(
                        ffExportDetail.shippingLine,
                        ffExportDetail.shippingID
                      )
                      " />
                  <span id="ShippingIdError"></span>
                  <span class="error" v-if="ffExportDetail.shippingLineCon_err ? true : false">{{
                    ffExportDetail.shippingLineCon_err }}</span>
                </b-col>
                <b-col md="3" v-if="SBDetail.pay_to == 'Forwarder'">
                  <label>Forwarder Name <span class="error">*</span></label>
                  <model-list-select
                    :list="$store.getters['common/getAllClientList']"
                    v-model="SBDetail.forwarder_id"
                    option-value="clientId"
                    option-text="clientName"
                    placeholder="Select Forwarder"
                    @input="getForwarderName(SBDetail.forwarder_id)"
                  ></model-list-select>
                  <span class="error" v-if="SBDetail.forwarder_id_err ? true : false">{{ SBDetail.forwarder_id_err }}</span>
                </b-col>
                <b-col md="3">
                  <label>Estimated SOB Date <span class="error">*</span></label>
                  <date-picker @input="getDueDate" :disabled="(accounts == true && role != 'Admin') || SBDetail.ffSlinePayId != ''
                    ? true
                    : false
                    " lang="en" :format="selectDateFormat" name="sobDate" id="sobDate" v-model="SBDetail.sobDate"
                    :minute-step="1"></date-picker>
                  <span class="error" v-if="SBDetail.sobDate_err ? true : false">{{
                    SBDetail.sobDate_err
                  }}</span>
                </b-col>
                <b-col md="2">
                  <label class="w-100">Payment Due Date<span class="error">*</span></label>
                  <date-picker :format="selectDateFormat" disabled lang="en" name="sobDate" id="sobDate"
                    v-model="SBDetail.dueDate" :minute-step="1"></date-picker>
                  <span class="error" v-if="SBDetail.dueDate_err ? true : false">{{
                    SBDetail.dueDate_err
                  }}</span>
                </b-col>
                <b-col md="4">
                  <label class="w-100">B/L Type<span class="error">*</span></label>
                  
                  <model-list-select :list="blTypeList" v-model="SBDetail.blType" option-value="blTypeVal"
                    option-text="blTypeTxt" placeholder="Select B/L Type" :isDisabled="SBDetail.blType != '' &&
                      SBDetail.blLandingId != '' &&
                      $sessionsStorage.get('designation') != 'Admin'
                      ? true
                      : false
                      "></model-list-select>
                  <span class="error" v-if="SBDetail.blType_err ? true : false">{{
                    SBDetail.blType_err
                  }}</span>
                </b-col>
                <b-col md="12">
                  <UpdateContainerWithSOB v-if="ffExportDetail.allModuleId"
                    :allModuleId="Number(ffExportDetail.allModuleId)" :JobNo="ffExportDetail.ffExportFclSeries"  @update="refreshData" />
                </b-col>
              </b-row>

              <hr />

              <b-row>
                <b-col md="6">
                  <label>B/L Draft By Shipping Line<span class="error">*</span></label>
                  <multi-file-uploader :disabled="(accounts == true && role != 'Admin') || SBDetail.ffSlinePayId != ''
                    ? true
                    : false
                    " :index="0" :second_index="0" :style="`height: 79px;    background: darkgray;    width: 300px;`"
                    :documentName="'Sea_Export_SlinePay_BLDraft_'" :otherDocName="'Sea_Export_SlinePay_BLDraft_'"
                    :folderName="'BL_DRAFT'" :accept="'*'"
                    :assign_no="ffExportDetail.ffExportFclSeries.replaceAll('/', '_')" :multiple="true"
                    v-model="SBDetail.blDraftUpload" :state="Boolean(SBDetail.blDraftUpload)"
                    :fileAllModuleId="SBDetail.allModuleId"></multi-file-uploader>
                  <a v-if="SBDetail.blDraftUpload && SBDetail.blDraftUpload" href="javascript:void(0)" @click="openSignedDocument(`ASSIGNMENT_UPLOADS/${ffExportDetail.ffExportFclSeries.replaceAll('/', '_')}/${SBDetail.blDraftUpload}`)">--View</a>
                  <span class="error" v-if="SBDetail.blDraftUpload_err ? true : false">{{
                    SBDetail.blDraftUpload_err
                  }}</span>
                </b-col>

                <b-col md="4" class="ml-5" v-if="FFSeaExportArr.length > 0">
                  <label>FF SEA EXPORT Quotation</label>
                  <table border="1" style="width: 140%; text-align: center">
                    <thead>
                      <tr>
                        <th>SN</th>
                        <th>Particulars</th>
                        <th>Buying Rate</th>
                        <th>Remark</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in FFSeaExportArr" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td><b>{{ item.ffType }}</b></td>
                        <td><b>{{ item.buyingRate + " " + item.currency }}</b></td>
                        <td><b>{{ item.line_wise_remark }}</b></td>
                      </tr>
                    </tbody>
                  </table>
                </b-col>
              </b-row>
              <b-row v-if="oceanFreight.indexOf('OCEAN FREIGHT') >= 0">
                <b-col md="2">
                  <label> Ocean Freight Rates<span class="error">*</span></label>
                  <b-form-input :disabled="ffExportDetail.disable_oe_oceanf_rate" :formatter="capitalizeAll"
                    name="freightRates" id="freightRates" v-model="ffExportDetail.oe_oceanf_rate"
                    type="number"></b-form-input>
                  <span class="error" v-if="ffExportDetail.oceanFreightRate_err ? true : false">{{
                    ffExportDetail.oceanFreightRate_err }}</span>
                </b-col>

                <b-col md="2">
                  <label>Currency<span class="error">*</span></label>
                  <model-list-select :list="$store.getters['common/getAllCurrencyList']"
                    :isDisabled="ffExportDetail.disable_oe_fk_currency_id" v-model="ffExportDetail.oe_fk_currency_id"
                    option-value="currency_id" option-text="currencyCode"
                    placeholder="Select Currency"></model-list-select>
                  <span class="error" v-if="ffExportDetail.currency_err ? true : false">{{
                    ffExportDetail.currency_err
                  }}</span>
                </b-col>

                <b-col md="3">
                  <label>Remark :</label>
                  <b-form-textarea :disabled="ffExportDetail.disable_oe_oceanf_remark" :formatter="capitalizeAll"
                    id="remark" name="remark" v-model="ffExportDetail.oe_oceanf_remark"></b-form-textarea>
                </b-col>
              </b-row>

              <b-row class="mt-3">
                <b-col md="4">
                  <b-button v-if="
                    (accounts != true || $sessionsStorage.get('nameUser') == 'Bhavneesh') && getFailedSobCont.length >= 0
                  " :disabled="(ffExportDetail.shippingID != ffExportDetail.shippingId || !SBDetail.blType)
                    ? true
                    : false
                    " id="show-btn" size="sm" variant="outline-primary" @click="addInvArry">
                    Add Invoice <i class="fa fa-plus" aria-hidden="true"></i></b-button>
                </b-col>
              </b-row>

              <b-card class="mt-2" v-for="(itm, idx) in lineInvModalArray" :key="idx">
                <div class="d-flex align-items-center" v-if="idx != 0">
                  <b-button :disabled="itm.ffSlineInvId != '' ? true : false" class="ml-auto" id="show-btn" size="sm"
                    variant="danger" @click="removeInvArry(idx)">
                    Remove Invoice <i class="fa fa-plus" aria-hidden="true"></i></b-button>
                </div>

                <RemoveSlineInvoiceButton v-if="ffExportDetail.allModuleId && SBDetail.ffSlinePayId"
                  :BTNTitle="'Remove Single Invoice'" :Type="'Single'" :SlineType="'FFSline'" :TransportType="'Export'"
                  :SlinePayId="SBDetail.ffSlinePayId" :SlineInvId="itm.ffSlineInvId || ''"
                  :allModuleId="ffExportDetail.allModuleId" @refresh-data="refreshData" />

                <div class="mt-2" v-if="SBDetail.revisedMail != 0">
                  <input :disabled="itm['invCurrencyList'][0].invPayStatus == 2 || itm['invCurrencyList'][0].invPayStatus == 1
                    ? true: false
                    " :id="'checkbox-' + idx" type="checkbox" @click="addRevisedInvoice(idx, 'checkbox-' + idx)" />
                  <span class="error">Revise Invoice</span>
                </div>

                <b-row>
                  <b-col md="3">
                    <label>Invoice Category<span class="error">*</span></label>
                    <b-form-radio-group v-model="itm.invCategory" :options="invCategoryList" class="mb-3"
                      value-field="payVal" text-field="payText" disabled-field="notEnabled"></b-form-radio-group>
                    <span class="error" v-if="itm.invCategory_err ? true : false">{{
                      itm.invCategory_err
                    }}</span>
                  </b-col>
                  <b-col md="3"><label>Invoice No<span class="error">*</span></label>
                    <b-form-input :formatter="capitalizeAll" :disabled="(accounts == true && role != 'Admin') || itm.ffSlineInvId != ''
                      ? true
                      : false
                      " name="shippingBillNo" id="shippingBillNo" v-model="itm.invNo"></b-form-input><span
                      class="error" v-if="itm.invNo_err ? true : false">{{
                        itm.invNo_err
                      }}</span></b-col>
                  <b-col md="6">
                    <label>Invoice Type<span class="error">*</span></label>
                    <multi-select :isDisabled="(accounts == true && role != 'Admin') || itm.ffSlineInvId != ''
                      ? true
                      : false
                      " :options="invoiceTypeList" :selected-options="itm.invType || []" placeholder="select Type"
                      v-model="itm.invType" @select="onSelect($event, $event, itm, idx)" :multiple="true">
                    </multi-select>
                    <span class="error" v-if="itm.invType_err ? true : false">{{
                      itm.invType_err
                    }}</span>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col cols="3">
                    <label>Invoice Date<span class="error">*</span></label>
                    <date-picker :format="selectDateFormat" lang="en" name="inv_date" id="inv_date"
                      v-model="itm.inv_date" :minute-step="1" />
                    <span class="error" v-if="itm.inv_date_err ? true : false">{{
                      itm.inv_date_err
                    }}</span>
                  </b-col>
                  <b-col md="4">
                    <label>Shipping Line Invoice (Drag & Drop)<span class="error">*</span></label>
                    <multi-file-uploader :disabled="(accounts == true && role != 'Admin') || itm.enableDisable == true
                      ? true
                      : false
                      " :index="0" :second_index="idx"
                      :style="`height: 79px;    background: darkgray;    width: 400px;`"
                      :documentName="'Sea_Export_SlinePay_SlineInv_'" :otherDocName="'Sea_Export_SlinePay_SlineInv_'"
                      :folderName="'Sline_Invoice'" :accept="'*'"
                      :assign_no="ffExportDetail.ffExportFclSeries.replaceAll('/', '_')" :multiple="true"
                      v-model="itm.invSlineUpload" :state="Boolean(itm.invSlineUpload)"
                      :fileAllModuleId="SBDetail.allModuleId"></multi-file-uploader>
                    <span class="error" v-if="itm.invSlineUpload_err ? true : false">{{
                      itm.invSlineUpload_err
                    }}</span>
                    <a v-if="itm.invSlineUpload && itm.invSlineUpload" href="javascript:void(0)" @click="openSignedDocument(`ASSIGNMENT_UPLOADS/${ffExportDetail.ffExportFclSeries.replaceAll('/', '_')}/${itm.invSlineUpload}`)">--View</a>
                    
                  </b-col>
                  <b-col md="2" class="mb-3">
                    <b-form-radio-group
                      v-model="itm.dispute_status"
                      :options="itm.ffSlineInvId && itm.dispute_status ? ['Under Dispute', 'Resolved'] : ['Under Dispute']"
                      name="dispute_status"
                      class="mt-4"
                    ></b-form-radio-group>
                  </b-col>
                  <b-col md="3" class="mb-3" v-if="itm.dispute_status">
                    <label class="small text-muted font-weight-bold">Sline Dispute Reason <span class="error">*</span></label>
                    <model-list-select
                      :list="$store.getters['common/getAllRemarkDDList']"
                      v-model="itm.sline_dispute"
                      option-value="label"
                      option-text="label"
                      placeholder="Search & Select SlineDispute"
                      @searchchange="searchSlineDispute"
                      @input="debounceSearch"
                      :isDisabled="itm.dispute_status === 'Resolved'"
                    />
                    <span class="error" v-if="itm.sline_dispute_err ? true : false">{{ itm.sline_dispute_err }}</span>
                  </b-col>
                </b-row>
                <div class="row mt-2">
                  <!-- Supplementary Comment Yes NO Section Start -->
                  <div class="col-md-4 row" v-if="itm.invCategory == 'Supplementary' || itm.dispute_status === 'Resolved'">
                    <label class="col-md-4">Bill to Shipper : <span class="error">*</span></label>
                    <div class="col-md-8">
                      <b-form-radio-group v-model="itm.scCategory" :options="SCCategoryList" class="mb-3"
                        value-field="SCVal" text-field="SCText" @input="
                          chnageSCCategoryList(
                            itm.scCategory,
                            itm.scCategory_err,
                            itm.scremark,
                            itm.scremark_err,
                            lineInvModalArray,
                            idx
                          )
                          "></b-form-radio-group>
                      <span class="error" v-if="
                        (itm.scCategory == '' ||
                          itm.scCategory == null ||
                          itm.scCategory == undefined) &&
                        itm.scCategory_err != ''
                      ">{{ itm.scCategory_err }}</span>
                    </div>
                  </div>
                  <div class="col-md-4 row" v-if="itm.scCategory == 'Yes' || itm.scCategory == 'No'">
                    <label class="col-md-3">Remark : <span class="error">*</span></label>
                    <div class="col-md-9">
                      <b-form-textarea :formatter="capitalizeAll" id="remark" name="remark"
                        v-model="itm.scremark"></b-form-textarea>
                      <span class="error" v-if="
                        itm.scremark == '' ||
                        itm.scremark == null ||
                        itm.scremark == undefined
                      ">
                        Bill to Shipper Remark Field is Required</span>
                    </div>
                  </div>
                  <div class="col-md-4 row" v-if="itm.dispute_status === 'Resolved' && itm.scCategory==='Yes'">
                    <label class="col-md-3">Amount : <span class="error">*</span></label>
                    <div class="col-md-9">
                      <b-form-input type="number" v-model="itm.resolved_amount"></b-form-input>
                      <span class="error" v-if="itm.resolved_amount_err">{{ itm.resolved_amount_err }}</span>
                    </div>
                  </div>
                  <!-- Supplementary Comment Yes NO Section End -->
                </div>
                

                <b-card class="mt-2" v-for="(currItm, currIdx) in itm['invCurrencyList']" :key="currIdx">
                  <div>
                    <!-- REMOVE AMOUNT BUTTON  -->
                    <b-row v-if="currIdx != 0">
                      <b-col>
                        <div class="d-flex align-items-center mt-3">
                          <b-button class="ml-auto" id="show-btn" size="sm" variant="outline-danger"
                            @click="removeInvCurrency(idx, currIdx)">
                            REMOVE AMOUNT
                            <i class="fa fa-plus" aria-hidden="true"></i></b-button>
                        </div>
                      </b-col>
                    </b-row>

                    <!-- AMOUNT FIELDS START  -->

                    <div>
                      <b-row>
                        <b-col md="3">
                          <label>Invoice Amount<span class="error">*</span></label>
                          <b-form-input :formatter="capitalizeAll" :disabled="(accounts == true && role != 'Admin') ||
                            itm.enableDisable == true
                            ? true
                            : false
                            " name="shippingBillNo" id="shippingBillNo" v-model="currItm.invAmount"
                            type="number"></b-form-input><span class="error"
                            v-if="currItm.invAmount_err ? true : false">{{ currItm.invAmount_err }}</span></b-col>

                        <b-col md="3"><label>Currency<span class="error">*</span></label>

                          <model-list-select :isDisabled="(accounts == true && role != 'Admin') ||
                            itm.enableDisable == true
                            ? true
                            : false
                            " :list="currList" v-model="currItm.invCurrency" option-value="payVal"
                            option-text="payText" placeholder="Select Currency"></model-list-select>
                          <span class="error" v-if="currItm.invCurrency_err ? true : false">{{ currItm.invCurrency_err
                            }}</span>
                        </b-col>

                        <b-col md="3" v-if="
                          (SBDetail.ffSlinePayId != '' && accounts == true) ||
                          (SBDetail.ffSlinePayId != '' && role == 'Admin')
                        "><label>Payment Mode</label>

                          <model-list-select :isDisabled="(accounts != true && role != 'Admin') ||
                            currItm.invPayStatus != ''
                            ? true
                            : false
                            " :list="payList" v-model="currItm.invPayMode" option-value="payVal" option-text="payText"
                            placeholder="Select Mode"></model-list-select>
                          <span class="error" v-if="currItm.invPayMode_err ? true : false">{{ currItm.invPayMode_err
                            }}</span>
                        </b-col>
                        <b-col md="3" v-if="
                          (SBDetail.ffSlinePayId != '' && accounts == true) ||
                          (SBDetail.ffSlinePayId != '' && role == 'Admin')
                        "><label>Payment Ref</label>
                          <b-form-input :disabled="accounts != true ||
                            (currItm.invPayStatus != '' &&
                              $sessionsStorage.get('cust_username') !=
                              'laxmi@pridel.com' &&
                              role != 'Admin')
                            ? true
                            : false
                            " :formatter="capitalizeAll" name="shippingBillNo" id="shippingBillNo"
                            v-model="currItm.invPayRef"
                            @input="cahngeDisableButton(currItm.invPayRef)"></b-form-input><span class="error"
                            v-if="currItm.invPayRef_err ? true : false">{{ currItm.invPayRef_err }}</span></b-col>
                      </b-row>

                      <b-row v-if="
                        (SBDetail.ffSlinePayId != '' && accounts == true) ||
                        (SBDetail.ffSlinePayId != '' && role == 'Admin')
                      ">
                        <b-col md="4"><label>Payment Amount</label>
                          <b-form-input :disabled="(accounts != true && role != 'Admin') ||
                            currItm.invPayStatus != ''
                            ? true
                            : false
                            " :formatter="capitalizeAll" name="shippingBillNo" id="shippingBillNo"
                            v-model="currItm.invPaidAmount"></b-form-input>
                          <span class="error" v-if="currItm.invPaidAmount_err ? true : false">{{
                            currItm.invPaidAmount_err }}</span></b-col>
                        <b-col md="4"><label class="w-100">Payment Date</label>
                          <date-picker :disabled="accounts != true ||
                            (currItm.invPayStatus != '' &&
                              $sessionsStorage.get('cust_username') !=
                              'laxmi@pridel.com' &&
                              role != 'Admin')
                            ? true
                            : false
                            " :format="selectDateFormat" lang="en" name="shippingBillNo" id="shippingBillNo"
                            v-model="currItm.invPayDate" :minute-step="1"
                            @input="cahngeDisableButton(currItm.invPayDate)"></date-picker>
                          <span class="error" v-if="currItm.invPayDate_err ? true : false">{{ currItm.invPayDate_err
                            }}</span>
                        </b-col>
                        <b-col md="4"><label>Payment Status</label>

                          <model-list-select :isDisabled="(accounts != true && role != 'Admin') ||
                            currItm.invPayStatus != ''
                            ? true
                            : false
                            " :list="statusList" v-model="currItm.invPayStatus" option-value="payVal"
                            option-text="payText" placeholder="Select Status"></model-list-select>
                          <span class="error" v-if="currItm.invPayStatus_err ? true : false">{{ currItm.invPayStatus_err
                            }}</span>
                        </b-col>
                        <b-col></b-col>
                      </b-row>
                    </div>

                    <!-- AMOUNT FIELDS END  -->
                  </div>
                </b-card>
              </b-card>
              <b-row>
                <b-col md="12">
                  <md-layout md-flex="25">
                  
                    <b-button v-if="lineInvModalArray.length > 0" :disabled="addSBDetail_button == true || ((ffExportDetail.shippingId != ffExportDetail.shippingID ||
                      SBDetail.paymentDone == '1' ||
                      disableSaveSubmit == true) && !isDisputeResolved)
                      ? true
                      : false
                      " class="mt-3" variant="primary" id="addButtonLoaderSB" @click="addSBDetail">Save & Submit
                    </b-button>

                    <md-spinner md-indeterminate id="loaderSB" style="display: none"></md-spinner>
                  </md-layout>
                </b-col>
              </b-row>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <div>
      <b-modal id="supModal" ref="my-modal" size="xl" hide-footer title="">
        <suplimentry-inv :suplimentaryInvDataSingleArry="getSuplimentaryInvData" :key="componentKey" />
        <b-button class="mt-3" variant="outline-danger" block @click="hideModal">Close</b-button>
      </b-modal>
    </div>
    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="popMailAfter"></md-dialog-confirm>

    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-confirm>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import BannerComponent from "../allModuleForm/bannerComponent.vue";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import SuplimentryInv from "./ffSLineSuplimentryPayment.vue";
import Multiselect from "vue-multiselect";
import MultiFileUploader from "../common/MultiSlineFileUploader.vue";
import RemoveSlineInvoiceButton from "../common/RemoveSlineInvoiceButton.vue";
import UpdateContainerWithSOB from '../Pendency/UpdateContainerWithSOB.vue';

import {
  globalPermissionStatus,
  GlobalGetLocation,
  GlobalContainerValid,
} from "../../helper/collection";
import NodeLockPannelService from "../../services/NodeLockPannelService.js";

export default {
  beforeMount() {
    this.$store.dispatch("common/setAllRemarkDDList", { search_txt: "",ModuleType:"SLINE DISPUTE" });
    this.$store.dispatch(
        "common/setAllClientList",
        JSON.stringify({
            itemCode: "ClientList",
            ClientType:"Freight_Forwarder",
        })
    );
    this.$store.dispatch("common/setAllAgentColoaderList");
    this.$store.dispatch(
      "common/setAllColoaderList",
      JSON.stringify({
        itemCode: "ColoderList",
        status: "1",
        categoryType: "CoLoader",
      })
    );
    if (
      (globalPermissionStatus("Sea Freight") || globalPermissionStatus("Accounts")) &&
      this.$sessionsStorage.get("editExportFCLId") != undefined &&
      this.$sessionsStorage.get("editExportFCLId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/freightForward/ffSLinePaymentExport");

      this.$store.dispatch(
        "common/setAllShippingLineList",
        JSON.stringify({
          itemCode: "ShippingLineList",
        })
      );
      this.$store.dispatch(
        "common/setAllCurrencyList",
        JSON.stringify({ Currency: "Currency_DropDown" })
      );
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  watch: {
    ContainerTypeSizefactory: {
      handler(newVal, oldVal) {
        if (newVal.hasOwnProperty("containerNo")) {
          this.ContainerTypeSizefactory.containerNo = newVal.containerNo.toUpperCase();

          if (this.ContainerTypeSizefactory.packageId != "") {
            let arrayNew = this.packageNameList.filter((x) => {
              return x.packageId == this.ContainerTypeSizefactory.packageId;
            });

            if (arrayNew.length > 0) {
              this.ContainerTypeSizefactory.packageName = arrayNew[0].packageName;
            }
          }
        }
      },
      deep: true,
    },
  },

  data() {
    return {
      getFailedSobCont: [],
      FFSeaExportArr: [],
      oceanFreight: [],
      disableSaveSubmit: false,
      addSBDetail_button: false,
      syncFlag: false,
      invnoErrFlag: false,
      invnoErrMsg: "",
      selectDateFormat,
      accounts: globalPermissionStatus("Accounts"),
      invBlDraftUpload: "",
      componentKey: 0,
      revisedInvoiceDetails: [],
      selectedInvoice: [],
      items: [],
      lastSelectItem: {},
      payList: [
        {
          payVal: "1",
          payText: "RTGS",
        },
        {
          payVal: "2",
          payText: "Cheque",
        },
      ],
      statusList: [
        // {
        //   payVal: "1",
        //   payText: "PARTIAL",
        // },
        {
          payVal: "2",
          payText: "COMPLETED",
        },
      ],
      payToOptions: [
        {
          payVal: "Line",
          payText: "Pay to LINE",
        },
        {
          payVal: "Forwarder",
          payText: "Pay to FORWARDER",
        },
      ],
      currList: [
        {
          payVal: "INR",
          payText: "INR",
        },
        {
          payVal: "USD",
          payText: "USD",
        },
      ],
      invCategoryList: [
        {
          payVal: "Supplementary",
          payText: "Supplementary",
          notEnabled: true,
        },
        {
          payVal: "Normal",
          payText: "Normal",
          notEnabled: true,
        },
      ],
      SCCategoryList: [
        {
          SCVal: "Yes",
          SCText: "Yes",
          // notEnabled: true,
        },
        {
          SCVal: "No",
          SCText: "No",
          // notEnabled: true,
        },
      ],

      invoiceTypeList: [
        {
          value: "1",
          text: "OCEAN FREIGHT",
        },
        {
          value: "2",
          text: "DETENTION CHARGES",
        },
        {
          value: "3",
          text: "SURRENDER CHARGES",
        },
        {
          value: "4",
          text: "LDC CHARGES",
        },
        {
          value: "5",
          text: "LOCAL CHARGES",
        },
        //Extra Added
        {
          value: "6",
          text: "SEAL CHARGES",
        },
        {
          value: "7",
          text: "VIA CHARGES",
        },
        {
          value: "8",
          text: "STORAGE CHARGES",
        },
        {
          value: "9",
          text: "ROLL-ON CHARGES",
        },
        {
          value: "10",
          text: "TERMINAL HANDLING CHARGES (THC)",
        },
        {
          value: "11",
          text: "SEAWAY BL CHARGES",
        },
        {
          value: "12",
          text: "ORIGINAL BL CHARGES",
        },

        {
          value: "13",
          text: "B/L AMENDMENT CHARGES",
        },
        {
          value: "14",
          text: "DESTINATION CHARGES",
        },
        {
          value: "15",
          text: "CREDIT NOTE",
        },
        {
          value: "16",
          text: "BOOKING CANCELLATION",
        },
      ],
      showAlgo: false,
      algoConNo: "",
      docURL: URL_BASE_DOC,
      isLoading: false,
      value12: "",
      CCdone: "",
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      unitList: [
        {
          uT: "KGS",
          uV: "KGS",
        },
        {
          uT: "MT",
          uV: "MT",
        },
      ],

      CCList: [
        {
          ccInfoVal: "Yes",
          ccInfoText: "Yes",
        },
        {
          ccInfoVal: "No",
          ccInfoText: "No",
        },
      ],
      getContainerList: [],
      getLocationList: [],
      ffExportDetail: {
        POD: "",
        allModuleId: "",
        clientName: "",
        ffExportFclSeries: "",
        portType: "",
        stuffingType: "",
        containerInfo: "",
        mergeffExportId: "",
        mergeSeries: "",
        shippingLine: "",
        FinalPlace: "",
        POR: "",
        username: "",
        shippingID: "",
        oe_oceanf_rate: "",
        disable_oe_oceanf_rate: false,
        oe_fk_currency_id: "1",
        disable_oe_fk_currency_id: false,
        oe_oceanf_remark: "",
        disable_oe_oceanf_remark: false,
      },
      POD: "",
      POD_err: "",
      blTypeList: [
        {
          blTypeVal: "HouseBL",
          blTypeTxt: "House B/L",
        },
        {
          blTypeVal: "LinerBL",
          blTypeTxt: "Liner B/L",
        },
      ],
      SBDetail: {
        blType_err: "",
        dueDate_err: "",
        sobDate_err: "",
        blDraftUpload_err: "",
        SlineBlNo_err: "",
        pay_to_err: "",

        // POD_err: "",

        POD: "",
        revisedMail: "0",
        pay_to: "",
        forwarderName:"",
        forwarder_id: "",
        forwarder_id_err: "",
        blType: "",
        blLandingId: "",
        dueDate: "",
        SlineBlNo: "",
        invoiceAmount: "",
        sobDate: "",
        // allModuleId: "",
        allModuleId: this.$sessionsStorage.get("editSalesExId"),
        paymentDone: "",
        userId: "",
        stuffingType: "",
        blDraftUpload: "",
        slineInvoice: "",
        suplimentaryInvCount: "",
        ffSlinePayId: "",
        ffExportFclId: "",
        ffBookingId: "",
        ffExecutionId: "",

        paymentMode: "",
        totalAmount: "",
        payRefNumber: "",
        payDate: "",
        salesExeuctionNo: "",
        sline: "",
        clientName: "",
        shippingID: "",
        oe_oceanf_rate: "",
        disable_oe_oceanf_rate: false,
        oe_fk_currency_id: "1",
        disable_oe_fk_currency_id: false,
        oe_oceanf_remark: "",
        disable_oe_oceanf_remark: false,
      },

      errorSBExecution: {
        // shippingBillDate: "",
        // shippingBillNo: "",
        sobDate: "",
        SlineBlNo: "",

        cargoGrossWeight: "",
      },
      arraySBExecutionError: [
        "Enter Shippping Bill Date",
        "Enter Shipping Bill No",
        "Enter Cargo Weight",
      ],
      errorAtleastSb: "",
      errorAtleastContainer: "",

      WarehouseStuffing: {
        vgmSubmissionDate: "",
        gateInDate: "",
        siSubmissionDate: "",
        ffExecutionId: "",
        ffExportFclId: this.$sessionsStorage.get("editExportFCLId"),
        ffBookingId: this.$sessionsStorage.get("editFFBookingId"),

        stuffingType: "",
        portType: "",

        nameOfCFS: "",
        cartingDate: "",
        crnNumber: "",

        custmClearByPridel: "",
        ccAsignmentNo: "",
        containerInfo: "",
      },
      permissionStatus: true,
      sbDetailArray: [],
      suplimentaryInvData: [],
      getSuplimentaryInvData: [],
      showMoreSB: false,

      errorExecution: {
        cartingDate: "",
        crnNumber: "",
      },
      nameOfCFSError: "",
      arrayExecutionError: ["Select Carting Date", "Enter CRN Number"],

      ContainerTypeSizefactory: {
        netWeight: "",
        weightUnit: "",
        ffExecutionContainerId: "",
        containerTypeId: "",
        containerType: "",
        containerNo: "",
        cargoWeight: "",
        tareWeight: "",
        grossWeight: "",
        customSealNo: "",
        LineSealNo: "",
        cargoStuffingDate: "",
        leeoDate: "",
        leeoNo: "",
        handoverDate: "",
        measurement: "",
        packageId: "",
        packageName: "",
        noOfpkgUnit: "",
      },

      removeContainerVmodel: {
        ffExecutionContainerId: "",
        containerTypeId: "",
        containerType: "",
        containerNo: "",
        cargoWeight: "",
        tareWeight: "",
        grossWeight: "",
        customSealNo: "",
        LineSealNo: "",
        measurement: "",
        packageId: "",
        packageName: "",
        noOfpkgUnit: "",
      },
      role: this.$sessionsStorage.get("designation"),
      packageNameList: [],
      nextPageType: "",

      errorContainer: {
        containerTypeId: "",
        containerNo: "",
        grossWeight: "",
        //    measurement: "",
        packageId: "",
        noOfpkgUnit: "",
      },
      arrayContainerError: [
        "Select Container Type",
        "Enter Container No.",
        "Enter Container Gross Weight1",
        // "Enter measurement",
        "Select Package",
        "Enter No of Packages",
      ],
      ContainerFromTPT: [],
      ContainerNoTPT: [],
      ContainerNoTypeTPT: [],
      editIndex: "",
      deleteId: "",
      showDivCountNote: false,
      lineInvModalArray: [],
      oceanFreightDetails: [],
      BookingShippingLine: {
        assignmentNumber: "",
        bookingNumber: "",
        uploadBooking: "",
        validityBookingDate: "",
        bookingDate: "",
        vesselName: "",
        SICutOff: "",
        gateOpenDate: "",
        gateOpenTime: "",
        gateCloseDate: "",
        gateCloseTime: "",
        portCutDate: "",
        portCutTime: "",
        ENSCutDate: "",
        ENSCutTime: "",
        bookingShipment: "",
        stuffingType: "",
        vesselEta: "",
        vesselEtd: "",
        vgmCutOffDate: "",
        documentCutOffDate: "",
        voyageNo: "",
      },
      validateTrans: true,
      validateSB: true,
      containerTypeDetailFactory: [],
      containerNoRegexError: "",
      fileType: "",
      fileUrl: "",
      sob_date_detected:"",
    };
  },

  mounted() { },

  destroyed() { },
  components: {
    DatePicker,
    ModelListSelect,
    MultiSelect,
    // Loading,
    CustomLoader,
    SuplimentryInv,
    BannerComponent,
    Multiselect,
    MultiFileUploader,
    RemoveSlineInvoiceButton,
    UpdateContainerWithSOB,
  },
  computed: {
    isDisputeResolved() {
      return this.lineInvModalArray.some((itm) => itm.dispute_status === "Resolved");
    },
    disableSave() {
      return this.accounts == false &&
        this.role != "Admin" &&
        (!this.SBDetail.SlineBlNo ||
          !this.SBDetail.invoiceAmount ||
          !this.SBDetail.sobDate)
        ? true
        : false;
    },
    viewBLDraftDoc() {
      return this.SBDetail.blDraftUpload != ""
        ? this.SBDetail.blDraftUpload.split(",")
        : [];
    },
    viewInvDoc() {
      return this.SBDetail.slineInvoice != ""
        ? this.SBDetail.slineInvoice.split(",")
        : [];
    },

    viewSlineInvDoc() {
      return this.SBDetail.slineInvoice != ""
        ? this.SBDetail.slineInvoice.split(",")
        : [];
    },
    sbDetailArrayList() {
      return this.sbDetailArray;
    },
    containerTypeDetailFactoryList() {
      return this.containerTypeDetailFactory;
    },
    ContainerTypeList() {
      return this.getContainerList;
    },
    masterList() {
      return this.getLocationList;
    },
  },
  methods: {
    searchSlineDispute(val) {
      this.$store.dispatch("common/setAllRemarkDDList", { search_txt: val,ModuleType:"SLINE DISPUTE" });
    },
    debounceSearch(val) {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.searchSlineDispute(val);
      }, 500);
    },
    refreshData() {
      // Add the logic here to refresh the data in the parent component
      console.log("Data refreshed in the parent component");
      // Reset arrays to prevent undefined errors
      this.lineInvModalArray = [];
      this.containerTypeDetailFactory = [];
      // For example, you could re-fetch data from the API or update local data
      this.getData();
    },
    cahngeDisableButton(item) {
      if (item != undefined && item != null) {
        this.disableSaveSubmit = false;
        this.SBDetail.paymentDone = "";
      }
    },
    onSelectionChange(event) {
      // console.log("Events= > ", event);
    },

    onOceanFreightSelect() {
      this.oceanFreight = [];
      this.lineInvModalArray.forEach((items, inds) => {
        items.invType.forEach((item, ind) => {
          console.log("items.invType:", items.invType);
          this.oceanFreight.push(item.text);
        });
      });

      // this.oceanFreight.splice(index, 1);

      this.oceanFreight = [...new Set(this.oceanFreight)];
      console.log("new array:", this.oceanFreight);
    },

    onSelect(items, lastSelectItem, itemNew, index) {
      // console.log(items, lastSelectItem, itemNew);
      console.log("Selected items:", items);
      itemNew.invType = items;

      this.onOceanFreightSelect(items);
    },
    onSelect2(index, items, lastSelectItem) {
      this.items = items;
      this.lastSelectItem = lastSelectItem;
      this.lineInvModalArray[index].invTypeArr = items;

      this.lineInvModalArray[index].invType = JSON.stringify(this.items);
      // console.log(this.lineInvModalArray[index].invType);
    },
    // deselect option
    reset() {
      this.items = []; // reset
    },
    // select option from parent component
    selectFromParentComponent() {
      this.items = _.unionWith(this.items, [this.options[0]], _.isEqual);
      // console.log("Item =>", this.items);
    },
    addInvArry() {
      this.SBDetail.paymentDone = "";
      let invCategory_val = "";
      // alert(this.SBDetail.ffSlinePayId);
      if (this.SBDetail.ffSlinePayId == "") {
        invCategory_val = "Normal";
      } else {
        invCategory_val = "Supplementary";
      }
      this.disableSaveSubmit = false;
      //  console.log("Add invoice");
      let obj = {
        ffSlineInvId: "",
        enableDisable: false,
        invId: "",
        ffExportFclId: "",
        allModuleId: "",
        invSlineUpload: "",
        invBlDraftUpload: "",
        invNo: "",
        inv_date: "",
        invAmount: "",
        invCurrency: "",

        invCurrencyList: [
          {
            invAmount: "",
            invCurrency: "",
            invPayMode: "",
            invPaidAmount: "",
            invPayRef: "",
            invPayDate: "",
            invPayStatus: "",

            invAmount_err: "",
            invCurrency_err: "",
            invPayMode_err: "",
            invPaidAmount_err: "",
            invPayRef_err: "",
            invPayDate_err: "",
            invPayStatus_err: "",
          },
        ],
        invType: [],
        invCategory: invCategory_val,
        scCategory: "",
        scremark: "",
        invTypeArr: [],
        invPayMode: "",
        invPaidAmount: "",
        invPayRef: "",
        invPayDate: "",
        invPayStatus: "",

        dispute_status: "",
        sline_dispute: "",
        resolved_amount: "",

        invCategory_err: "",
        scCategory_err: "",
        scremark_err: "",
        invSlineUpload_err: "",
        invType_err: "",
        invNo_err: "",
        inv_date_err: "",
        sline_dispute_err: "",
        resolved_amount_err: "",
      };
      this.lineInvModalArray.push(obj);

      // console.log(this.lineInvModalArray.length);
    },

    addInvCurrency(index) {
      let obj = {
        invAmount: "",
        invCurrency: "",
        invPayMode: "",
        invPaidAmount: "",
        invPayRef: "",
        invPayDate: "",
        invPayStatus: "",
      };

      this.lineInvModalArray[index].invCurrencyList.push(obj);
    },

    RevisedAss(id) {
      // alert(id);
      var checkBox = document.getElementById(id).checked;
      // console.log("Id => " + id + " : " + checkBox);
      if (checkBox) {
        // console.log("lineInvModalArray",this.lineInvModalArray);return false;
        // this.SBDetail.blDraftUpload="",
        // this.SBDetail.sobDate="",
        // this.SBDetail.SlineBlNo="",
        // this.SBDetail.dueDate="",
        // this.items= [],
        // this.lastSelectItem= {}
        // for (let i = 0; i < lineInvModalArray.length; i++) {
        //   this.lineInvModalArray[i].invType = "";
        //   this.lineInvModalArray[i].invCategory = "";
        //   this.lineInvModalArray[i].invTypeArr = "";
        //   this.lineInvModalArray[i].invPayMode = "";
        //   this.lineInvModalArray[i].invPaidAmount = "";
        //   this.lineInvModalArray[i].invPayRef = "";
        //   this.lineInvModalArray[i].invPayDate = "";
        //   this.lineInvModalArray[i].invPayStatus = "";
        //   let obj = {
        //     invAmount: "",
        //     invCurrency: "",
        //     invPayMode: "",
        //     invPaidAmount: "",
        //     invPayRef: "",
        //     invPayDate: "",
        //     invPayStatus: "",
        //   }
        //   this.lineInvModalArray[i].invCurrencyList.push(obj)
        //    this.lineInvModalArray[i].invCurrencyList[i].invAmount ="";
        //    this.lineInvModalArray[i].invCurrencyList[i].invCurrency ="";
        //       // let obj = {
        //       //   invId: "",
        //       //   ccExportId: "",
        //       //   allModuleId: "",
        //       //   invSlineUpload: "",
        //       //   invBlDraftUpload: "",
        //       //   invNo: "",
        //       //   invAmount: "",
        //       //   invCurrency: "",
        //       //   invCurrencyList : [{
        //       //     invAmount: "",
        //       //     invCurrency: "",
        //       //     invPayMode: "",
        //       //     invPaidAmount: "",
        //       //     invPayRef: "",
        //       //     invPayDate: "",
        //       //     invPayStatus: "",
        //       //   }],
        //       //   invType: "",
        //       //   invCategory : "",
        //       //   invTypeArr: [],
        //       //   invPayMode: "",
        //       //   invPaidAmount: "",
        //       //   invPayRef: "",
        //       //   invPayDate: "",
        //       //   invPayStatus: "",
        //       // };
        //       // this.lineInvModalArray.push(obj);
        // }
        //  this.lineInvModalArray= []
      }
    },

    addRevisedInvoice(index, id) {
      var checkBox = document.getElementById(id).checked;
      // console.log("Id => " + id + " : " + checkBox);
      if (checkBox) {
        this.disableSaveSubmit = false;
        this.lineInvModalArray[index].enableDisable = false;
        this.lineInvModalArray[index]["Counter"] = index;
        this.revisedInvoiceDetails.push(this.lineInvModalArray[index]);
        // this.lineInvModalArray[index].invNo = "";
        this.lineInvModalArray[index].invSlineUpload = "";
        this.lineInvModalArray[index].invCurrencyList[0].invAmount = "";
        // this.lineInvModalArray[index].invSlineUpload = "";
        // this.lineInvModalArray[index].invCurrencyList[0].invAmount = "";
      } else {
        this.revisedInvoiceDetails.splice(index, 1);
      }

      // console.log("Revised mail => ", this.revisedInvoiceDetails);
    },

    removeInvArry(index) {
      this.lineInvModalArray.splice(index, 1);
      this.onOceanFreightSelect();
    },
    removeInvCurrency(invIndex, currIndex) {
      this.lineInvModalArray[invIndex].invCurrencyList.splice(currIndex, 1);
    },
    getSingleSupPay(itemId) {
      this.componentKey += 1;
      this.getSuplimentaryInvData = [];
      let arraysing = this.suplimentaryInvData.filter((y) => {
        return y.supffSlinePayId == itemId;
      });

      if (arraysing.length > 0) {
        this.getSuplimentaryInvData = arraysing;
        this.getSuplimentaryInvData[0][
          "suplimentaryInvCount"
        ] = this.SBDetail.suplimentaryInvCount;
        this.$refs["my-modal"].show();
      }
    },
    showModal() {
      this.componentKey += 1;
      this.getSuplimentaryInvData = [];
      this.$refs["my-modal"].show();
    },
    hideModal() {
      this.getSuplimentaryInvData = [];
      this.$refs["my-modal"].hide();
      this.getData();
    },

    getDueDate() {
      var date = new Date(this.SBDetail.sobDate);
      // console.log(date);
      if (this.ffExportDetail.shippingId == "15") {
        this.SBDetail.dueDate = date.setDate(date.getDate() + 9);
        this.SBDetail.dueDate = new Date(this.SBDetail.dueDate);
      } else if (this.ffExportDetail.shippingId == "8") {
        this.SBDetail.dueDate = date.setDate(date.getDate() + 9);
        this.SBDetail.dueDate = new Date(this.SBDetail.dueDate);
      } else if (this.ffExportDetail.shippingId == "13") {
        this.SBDetail.dueDate = date.setDate(date.getDate() + 9);
        this.SBDetail.dueDate = new Date(this.SBDetail.dueDate);
      } else if (this.ffExportDetail.shippingId == "27") {
        this.SBDetail.dueDate = date.setDate(date.getDate() + 13);
        this.SBDetail.dueDate = new Date(this.SBDetail.dueDate);
      } else {
        this.SBDetail.dueDate = date.setDate(date.getDate() + 6);
        this.SBDetail.dueDate = new Date(this.SBDetail.dueDate);
      }
    },
    onFileChangeBlDraft(ID, index) {
      this.isLoading = true;
      let files = event.target.files || event.dataTransfer.files;
      let exportfclId = this.$sessionsStorage.get("editExportFCLId");
      let formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);

        if (ID == "Sline_Invoice") {
          formData.append(
            "staticFileName",
            "Sea_Export_SlinePay_SlineInv_" + exportfclId
          );
        } else if (ID == "BL_DRAFT") {
          formData.append("staticFileName", "Sea_Export_SlinePay_BLDraft_" + exportfclId);
        }

        formData.append(
          "upload_dir_folderName",
          // "FF_Sea_Export_Sline_Payments_Uploads"
          this.ffExportDetail.ffExportFclSeries.replaceAll("/", "_")
        );
      }

      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Accept: ID + exportfclId,
        },
      };

      axios
        .post(`${URL_BASE}/uploadFileCommonForAllTest.php`, formData, config)
        .then((result) => {
          if (ID == "BL_DRAFT") {
            this.SBDetail.blDraftUpload = result.data;
          } else {
            this.lineInvModalArray[index].invSlineUpload = result.data;
            this.SBDetail.slineInvoice = result.data;
          }
          this.isLoading = false;
        })
        .catch((err) => {
          throw err;
        });
    },

    getConAlgoList() {
      //let self = this;

      if (this.ContainerTypeSizefactory.containerNo != "") {
        this.validContainerNo = GlobalContainerValid(
          this.ContainerTypeSizefactory.containerNo
        );
      }
    },

    doLoading() {
      this.isLoading = true;
    },
    doLoadingClose() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    previousSalesView() {
      window.history.go(-1);
    },

    // validateSBDetail() {
    //   let validate_new = true;
    //   Object.keys(this.errorSBExecution).map((x, index) => {
    //     if (this.SBDetail[x] == "") {
    //       this.errorSBExecution[x] = this.arraySBExecutionError[index];
    //       validate_new = false;
    //     }
    //   });

    //   console.log(this.errorSBExecution);

    //   if (validate_new == false) {
    //     this.validateSB = false;
    //   } else {
    //     this.validateSB = true;
    //   }
    // },
    showMoreSBDet() {
      if (this.showMoreSB == false) {
        this.ContainerTypeSizefactory.ffExecutionContainerId == "";
        this.showMoreSB = true;
      } else {
        this.showMoreSB = false;
      }
    },
    viewEdit(id, index) {
      let array = this.containerTypeDetailFactory.filter((x) => {
        return x.ffExecutionContainerId == id;
      });

      Object.keys(this.ContainerTypeSizefactory).map((x) => {
        this.ContainerTypeSizefactory[x] = array[0][x];
      });
      this.showMoreSB = false;
    },

    checkInvNo() {
      return new Promise((resolve) => {
        (this.SBDetail["module_type"] = "FF EXport"),
          (this.SBDetail["allModuleId"] = this.ffExportDetail.allModuleId),
          (this.SBDetail["ccExportId"] = this.$sessionsStorage.get("editExportFCLId"));
        this.SBDetail["CCExecutionId"] = this.$sessionsStorage.get("editFFExecutionId");
        this.SBDetail.invoiceDetails = this.lineInvModalArray;
        if (this.lineInvModalArray.length > 0) {
          let options = {
            method: "POST",
            url: `${URL_BASE}/Api_SlineBillingCCExport/checkInvNoExist.php`,
            data: JSON.stringify(this.SBDetail),
            crossDomain: true,

            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: this.$sessionsStorage.get("loginId"),
            },
          };

          axios(options)
            .then((result) => {
              const { statusText, status, data } = result;
              if (status == 200 && data) {
                // console.log(data);
                // console.log(data.find);
                // alert(data.find);
                if (data.find == 1) {
                  this.invnoErrFlag = true;
                } else if (data.find == 2) {
                  this.invnoErrFlag = true;
                } else if (data.find == 0) {
                  this.invnoErrFlag = false;
                }
                this.invnoErrMsg = data.msg || "";

                this.syncFlag = true;
                // console.log("Check");
                return resolve(!this.invnoErrFlag);
              }
            })
            .catch((error) => { });
        }
      });
    },
    validateSBDetail() {
      let validate_new = true;
      let i = 0;
      let errCount = 0;
      let errCount1 = 0;
      let errCount2 = 0;
      if (this.accounts != true || this.role == "Admin") {
        if (this.pay_to == "") {
          this.pay_to_err = "Pay To Field is Required";
          validate_new = false;
          ++errCount1;
        } else {
          this.pay_to_err = "";
          validate_new = true;
        }
        if (this.POD == "") {
          this.POD_err = "POD Field is Required";
          validate_new = false;
          ++errCount1;
        } else {
          this.POD_err = "";
          validate_new = true;
        }

        if (this.ffExportDetail.shippingLine == "") {
          this.ffExportDetail.shippingLine_err = "Shipping Line Field is Required";
          validate_new = false;
          ++errCount1;
        } else {
          this.ffExportDetail.shippingLine_err = "";
          validate_new = true;
        }

        if (
          this.ffExportDetail.oe_oceanf_rate == "" &&
          this.oceanFreight.indexOf("OCEAN FREIGHT") >= 0
        ) {
          this.ffExportDetail.oceanFreightRate_err = "Ocean Fright Rate is Required";
          validate_new = false;
          ++errCount1;
        } else {
          this.ffExportDetail.oceanFreightRate_err = "";
          validate_new = true;
        }

        if (
          this.ffExportDetail.oe_fk_currency_id == "" &&
          this.oceanFreight.indexOf("OCEAN FREIGHT") >= 0
        ) {
          this.ffExportDetail.currency_err = "Currency is Required";
          validate_new = false;
          ++errCount1;
        } else {
          this.ffExportDetail.currency_err = "";
          validate_new = true;
        }

        if (this.SBDetail.pay_to == '' || this.SBDetail.pay_to == 'Line') {
          if (this.ffExportDetail.shippingID == "") {
            this.ffExportDetail.shippingLineCon_err =
              "Shipping Line Confirmation Field is Required";
            validate_new = false;
            ++errCount1;
          } else {
            this.ffExportDetail.shippingLineCon_err = "";
            validate_new = true;
          }
        }

        if (this.SBDetail.pay_to == 'Forwarder') {
          if (this.SBDetail.forwarder_id == "") {
            this.SBDetail.forwarder_id_err = "Forwarder (Client) Field is Required";
            validate_new = false;
            ++errCount1;
          } else {
            this.SBDetail.forwarder_id_err = "";
            validate_new = true;
          }
        }

        if (this.SBDetail.SlineBlNo == "") {
          this.SBDetail.SlineBlNo_err = "B/L No. Field is Required";
          validate_new = false;
          ++errCount1;
        } else {
          this.SBDetail.SlineBlNo_err = "";
          validate_new = true;
        }

        if (this.SBDetail.blDraftUpload == "") {
          this.SBDetail.blDraftUpload_err = "B/L Draft Field is Required";
          validate_new = false;
          ++errCount1;
        } else {
          this.SBDetail.blDraftUpload_err = "";
          validate_new = true;
        }

        if (this.SBDetail.sobDate == "") {
          this.SBDetail.sobDate_err = "Estimated SOB Date Field is Required";
          validate_new = false;
          ++errCount1;
        } else {
          this.SBDetail.sobDate_err = "";
          validate_new = true;
        }

        if (this.SBDetail.dueDate == "") {
          this.SBDetail.dueDate_err = "Payment Due Date Field is Required";
          validate_new = false;
          ++errCount1;
        } else {
          this.SBDetail.dueDate_err = "";
          validate_new = true;
        }

        if (this.SBDetail.blType == "") {
          this.SBDetail.blType_err = "B/L Type Field is Required";
          validate_new = false;
          ++errCount1;
        } else {
          this.SBDetail.blType_err = "";
          validate_new = true;
        }

        if (this.SBDetail.pay_to == "") {
          this.SBDetail.pay_to_err = "SLINE Payment Flow is Required";
          validate_new = false;
          ++errCount1;
        } else {
          this.SBDetail.pay_to_err = "";
          validate_new = true;
        }


        let j = 0;
        // alert(this.lineInvModalArray.length);

        let MainARR = this.lineInvModalArray;
        for (let j = 0; j < MainARR.length; j++) {
          if (MainARR[j].invCategory == "") {
            this.lineInvModalArray[j]["invCategory_err"] =
              "Invoice Category Field is Required";
            validate_new = false;
            ++errCount;
            break;
          } else {
            this.lineInvModalArray[j]["invCategory_err"] = "";
            validate_new = true;
          }
          if (MainARR[j].invCategory == "Normal") {
            this.lineInvModalArray[j]["scremark_err"] = "";
            this.lineInvModalArray[j]["scCategory_err"] = "";
          }

          if (MainARR[j].invCategory == "Supplementary" || MainARR[j].dispute_status === "Resolved") {
            if (MainARR[j].scCategory == "No" || MainARR[j].scCategory == "Yes") {
              this.lineInvModalArray[j]["scCategory_err"] = "";
              validate_new = true;
            }
            if (
              MainARR[j].scCategory == "" ||
              MainARR[j].scCategory == null ||
              MainARR[j].scCategory == undefined
            ) {
              this.lineInvModalArray[j]["scCategory_err"] =
                "Bill to Shipper Field is Required";
              validate_new = false;
              ++errCount;
              break;
            } else {
              this.lineInvModalArray[j]["scCategory_err"] = "";
              validate_new = true;
            }

            if (MainARR[j].scCategory == "Yes" || MainARR[j].scCategory == "No") {
              if (
                MainARR[j].scremark == "" ||
                MainARR[j].scremark == null ||
                MainARR[j].scremark == undefined
              ) {
                this.lineInvModalArray[j]["scremark_err"] =
                  "Bill to Shipper Remark Field is Required";
                validate_new = false;
                ++errCount;
                break;
              } else {
                this.lineInvModalArray[j]["scremark_err"] = "";
                validate_new = true;
              }
            } else if (MainARR[j].scCategory == "No") {
              this.lineInvModalArray[j]["scCategory_err"] = "";
              validate_new = true;
              this.lineInvModalArray[j]["scremark_err"] = "";
              validate_new = true;
            }
          } else {
            this.lineInvModalArray[j]["scremark_err"] = "";
            validate_new = true;
            this.lineInvModalArray[j]["scCategory_err"] = "";
            validate_new = true;
          }
          if (MainARR[j].invSlineUpload == "") {
            this.lineInvModalArray[j]["invSlineUpload_err"] =
              "Shipping Line Invoice Field is Required";
            validate_new = false;
            ++errCount;
            break;
          } else {
            this.lineInvModalArray[j]["invSlineUpload_err"] = "";
            validate_new = true;
          }

          if (MainARR[j].invNo == "") {
            this.lineInvModalArray[j]["invNo_err"] = "Invoice No. Field is Required";
            validate_new = false;
            ++errCount;
            break;
          } else {
            this.lineInvModalArray[j]["invNo_err"] = "";
            validate_new = true;
          }

          if (MainARR[j].inv_date == "") {
            this.lineInvModalArray[j]["inv_date_err"] = "Invoice Date. Field is Required";
            validate_new = false;
            ++errCount;
            break;
          } else {
            this.lineInvModalArray[j]["inv_date_err"] = "";
            validate_new = true;
          }

          if (MainARR[j].invType == "") {
            this.lineInvModalArray[j]["invType_err"] = "Invoice Type Field is Required";
            validate_new = false;
            ++errCount;
            break;
          } else {
            this.lineInvModalArray[j]["invType_err"] = "";
            validate_new = true;
          }

          if (MainARR[j].dispute_status) {
            if (!MainARR[j].sline_dispute) {
              this.lineInvModalArray[j]["sline_dispute_err"] = "Sline Dispute Reason is Required";
              validate_new = false;
              ++errCount;
              break;
            } else {
              this.lineInvModalArray[j]["sline_dispute_err"] = "";
              validate_new = true;
            }
            if (MainARR[j].dispute_status === "Resolved" &&MainARR[j].scCategory === "Yes") {
              if (!MainARR[j].resolved_amount) {
                this.lineInvModalArray[j]["resolved_amount_err"] = "Amount is Required";
                validate_new = false;
                ++errCount;
                break;
              } else {
                this.lineInvModalArray[j]["resolved_amount_err"] = "";
                validate_new = true;
              }
            }
          }

          let MainARR2 = MainARR[j].invCurrencyList;
          for (let k = 0; k < MainARR2.length; k++) {
            if (MainARR2[k].invAmount == "") {
              this.lineInvModalArray[j].invCurrencyList[k]["invAmount_err"] =
                "Invoice Amount Field is Required";
              validate_new = false;
              ++errCount2;
              break;
            } else {
              this.lineInvModalArray[j].invCurrencyList[k]["invAmount_err"] = "";
              validate_new = true;
            }

            if (MainARR2[k].invCurrency == "") {
              this.lineInvModalArray[j].invCurrencyList[k]["invCurrency_err"] =
                "Invoice Currency Field is Required";
              validate_new = false;
              ++errCount2;
              break;
            } else {
              this.lineInvModalArray[j].invCurrencyList[k]["invCurrency_err"] = "";
              validate_new = true;
            }
          }
        }
      } else if (this.accounts == true || this.role == "Admin") {
        let MainARR = this.lineInvModalArray;
        for (let j = 0; j < MainARR.length; j++) {
          let MainARR2 = MainARR[j].invCurrencyList;
          for (let k = 0; k < MainARR2.length; k++) {
            if (MainARR2[k].invPaidAmount != "" || MainARR2[k].invPayStatus == "2") {
              if (MainARR2[k].invPaidAmount == "") {
                this.lineInvModalArray[j].invCurrencyList[k]["invPaidAmount_err"] =
                  "Payment Amount Field is Required";
                validate_new = false;
                ++errCount2;
                break;
              } else {
                this.lineInvModalArray[j].invCurrencyList[k]["invPaidAmount_err"] = "";
                validate_new = true;
              }

              if (MainARR2[k].invPayMode == "") {
                this.lineInvModalArray[j].invCurrencyList[k]["invPayMode_err"] =
                  "Payment Mode Field is Required";
                validate_new = false;
                ++errCount2;
                break;
              } else {
                this.lineInvModalArray[j].invCurrencyList[k]["invPayMode_err"] = "";
                validate_new = true;
              }

              if (MainARR2[k].invPayRef == "") {
                this.lineInvModalArray[j].invCurrencyList[k]["invPayRef_err"] =
                  "Payment Ref Field is Required";
                validate_new = false;
                ++errCount2;
                break;
              } else {
                this.lineInvModalArray[j].invCurrencyList[k]["invPayRef_err"] = "";
                validate_new = true;
              }
              if (MainARR2[k].invPayDate == "") {
                this.lineInvModalArray[j].invCurrencyList[k]["invPayDate_err"] =
                  "Payment Date Field is Required";
                validate_new = false;
                ++errCount2;
                break;
              } else {
                this.lineInvModalArray[j].invCurrencyList[k]["invPayDate_err"] = "";
                validate_new = true;
              }

              if (MainARR2[k].invPayStatus == "" || MainARR2[k].invPayStatus == "0") {
                this.lineInvModalArray[j].invCurrencyList[k]["invPayStatus_err"] =
                  "Payment Status Field is Required";
                validate_new = false;
                ++errCount2;
                break;
              } else {
                this.lineInvModalArray[j].invCurrencyList[k]["invPayStatus_err"] = "";
                validate_new = true;
              }
            }
          }
        }
      }
      // alert(errCount1);
      console.log("lineInvModalArray=>", this.lineInvModalArray);
      if (errCount > 0 || errCount2 > 0 || errCount1 > 0) {
        this.validateSB = false;
      } else {
        this.validateSB = true;
      }
      // if (validate_new == false) {
      //   this.validateSB = false;
      // } else {
      //   this.validateSB = true;
      // }
    },
    chnageSCCategoryList(
      scCategory,
      scCategory_err,
      scremark,
      scremark_err,
      lineInvModalArray,
      idx
    ) {
      this.lineInvModalArray[idx].scCategory_err = "";
      this.lineInvModalArray[idx].scremark_err = "";
    },
    checkDuplicateInvNo() {
      // Clear previous duplicate errors
      this.lineInvModalArray.forEach((itm) => {
        if (itm.invNo_err === "This Invoice No is entered more than once.") {
          itm.invNo_err = "";
        }
      });

      const seen = {};
      let duplicate = "";
      this.lineInvModalArray.forEach((itm) => {
        const no = (itm.invNo || "").trim().toUpperCase();
        if (!no) return;
        if (seen[no]) {
          duplicate = itm.invNo;
          itm.invNo_err = "This Invoice No is entered more than once.";
        } else {
          seen[no] = true;
        }
      });
      return duplicate;
    },
    async addSBDetail() {
      const dupInvNo = this.checkDuplicateInvNo();
      if (dupInvNo) {
        this.alert.content =
          "Invoice No " + dupInvNo + " is entered more than once. Please remove the duplicate.";
        this.$refs["addPop"].open();
        return false;
      }
      if (this.SBDetail.ffSlinePayId == "") {
        let checkValueExit = await this.checkInvNo();
        // console.log("checkValueExit", checkValueExit);

        if (!checkValueExit) {
          this.alert.content =
            this.invnoErrMsg ||
            "Payment request for one or more invoices has already been raised to Accounts. Kindly check.";
          this.$refs["addPop"].open();
          return false;
        }
      }
      if(this.sob_date_detected=="undefined" || this.sob_date_detected==null || this.sob_date_detected==""|| this.sob_date_detected==undefined || this.sob_date_detected=="null"){
        this.alert.content = "Please Select SOB In COntainer Date.";
        this.$refs["addPop"].open();
        return false;
      }
      console.log("After => ", this.SBDetail);
      this.validateSBDetail();
      //  alert(this.validateSB);
      //  return false;
      if (this.validateSB == false) {
        this.alert.content = "PLEASE ENTER ALL DETAILS.";
        this.$refs["addPop"].open();
        return false;
      }

      if (this.SBDetail.pay_to == 'Forwarder' && !this.SBDetail.forwarder_id) {
        this.alert.content = "PLEASE Select Forwarder name.";
        this.$refs["addPop"].open();
        return false;
      }

      this.SBDetail[
        "ffExportFclSeries"
      ] = this.ffExportDetail.ffExportFclSeries.replaceAll("/", "_");

      if (
        !this.SBDetail.slineInvoice ||
        (!this.SBDetail.blDraftUpload && this.SBDetail.ffSlinePayId == "")
      ) {
        // console.log(
        //   this.SBDetail.slineInvoice +
        //     " : " +
        //     this.SBDetail.blDraftUpload +
        //     " : " +
        //     this.SBDetail.ffSlinePayId
        // );
        this.alert.content = "Please Upload Shipping Line Invoice and BL Draft";
        this.$refs["addPop"].open();
        return false;
      }
      this.SBDetail.allModuleId = this.$sessionsStorage.get("editSalesExId");
      // alert(this.SBDetail.slineInvoice);
      this.SBDetail["uploadArray"] = [];
      if (this.SBDetail.slineInvoice) {
        if (this.SBDetail.ffSlinePayId == "") {
          let i = 0;
          this.lineInvModalArray.forEach((element) => {
            let obj = {
              allModuleId: this.ffExportDetail.allModuleId,
              docName:
                "SLINE_INVOICE-" +
                this.$sessionsStorage.get("editExportFCLId") +
                "_" +
                i,
              docLink: element["invSlineUpload"],
            };
            this.SBDetail.uploadArray.push(obj);
            i++;
          });
        } else if (this.SBDetail.ffSlinePayId != "") {
          let i = 0;
          this.lineInvModalArray.forEach((element) => {
            if (this.SBDetail.revisedMail != "1") {
              if (element.ffSlineInvCategory == "Supplementary") {
                let obj = {
                  allModuleId: this.ffExportDetail.allModuleId,
                  docName:
                    "suplimentrySlineInvoive_-" +
                    this.$sessionsStorage.get("editExportFCLId") +
                    "_" +
                    i,
                  docLink: element["invSlineUpload"],
                };
                this.SBDetail.uploadArray.push(obj);
              } else if (element.ffSlineInvCategory == "Normal") {
                let obj = {
                  allModuleId: this.ffExportDetail.allModuleId,
                  docName:
                    "SLINE_INVOICE-" +
                    this.$sessionsStorage.get("editExportFCLId") +
                    "_" +
                    i,
                  docLink: element["invSlineUpload"],
                };
                this.SBDetail.uploadArray.push(obj);
              }
            } else {
              let obj1 = {
                allModuleId: this.ffExportDetail.allModuleId,
                docName:
                  "SLINE_INVOICE-" +
                  this.$sessionsStorage.get("editExportFCLId") +
                  "_" +
                  i,
                docLink: element["invSlineUpload"],
              };
              this.SBDetail.uploadArray.push(obj1);
            }
            i++;
          });
        }
        // Added By Priyanshu Singh End
      }
      if (this.SBDetail.blDraftUpload) {
        if (this.SBDetail.ffSlinePayId == "") {
          let obj1 = {
            allModuleId: this.ffExportDetail.allModuleId,
            docName:
              "BL_LINEINVOICEREQ-" + this.$sessionsStorage.get("editExportFCLId"),
            docLink: this.SBDetail.blDraftUpload,
          };
          this.SBDetail.uploadArray.push(obj1);
        } else if (this.SBDetail.ffSlinePayId != "") {
          let Category = "";
          this.lineInvModalArray.forEach((element) => {
            Category = element.ffSlineInvCategory;
          });
          if (this.SBDetail.revisedMail != "1") {
            if (Category == "Supplementary") {
              let obj1 = {
                allModuleId: this.ffExportDetail.allModuleId,
                docName:
                  "suplimentrySlineBLDraft_-" +
                  this.$sessionsStorage.get("editExportFCLId"),
                docLink: this.SBDetail.blDraftUpload,
              };
              this.SBDetail.uploadArray.push(obj1);
            } else if (Category == "Normal") {
              let obj1 = {
                allModuleId: this.ffExportDetail.allModuleId,
                docName:
                  "BL_LINEINVOICEREQ-" +
                  this.$sessionsStorage.get("editExportFCLId"),
                docLink: this.SBDetail.blDraftUpload,
              };
              this.SBDetail.uploadArray.push(obj1);
            }
          } else {
            let obj1 = {
              allModuleId: this.ffExportDetail.allModuleId,
              docName:
                "BL_LINEINVOICEREQ-" + this.$sessionsStorage.get("editExportFCLId"),
              docLink: this.SBDetail.blDraftUpload,
            };
            this.SBDetail.uploadArray.push(obj1);
          }
        }
      }

      this.SBDetail["stuffingType"] = this.WarehouseStuffing.stuffingType;
      this.SBDetail["ffExportFclId"] = this.$sessionsStorage.get("editExportFCLId");
      this.SBDetail["ffBookingId"] = this.$sessionsStorage.get("editFFBookingId");
      this.SBDetail["ffExecutionId"] = "0";
      this.SBDetail.clientName = this.ffExportDetail.clientName;
      this.SBDetail.sline = this.ffExportDetail.shippingLine;
      this.SBDetail.POD = this.ffExportDetail.POD;
      this.SBDetail.salesExeuctionNo = this.ffExportDetail.ffExportFclSeries;
      this.SBDetail["Accounts"] = globalPermissionStatus("Accounts");
      this.SBDetail["role"] = this.role;
      this.SBDetail.shippingID = this.ffExportDetail.shippingID;
      this.SBDetail.invoiceDetails = this.lineInvModalArray;

      this.SBDetail.oe_oceanf_rate = this.ffExportDetail.oe_oceanf_rate;
      this.SBDetail.oe_fk_currency_id = this.ffExportDetail.oe_fk_currency_id;
      this.SBDetail.oe_oceanf_remark = this.ffExportDetail.oe_oceanf_remark;

      if (this.revisedInvoiceDetails.length > 0) {
        this.SBDetail.revisedInvoiceDetails = this.revisedInvoiceDetails;
      }
      // console.log("After => ", this.SBDetail);
      // return false
      this.validateSBDetail();
      console.log("Validation => ", this.validateSB);
      // this.validateSB = false;
      // return false;
      if (this.validateSB != false) {
        this.addSBDetail_button = true;
        $("#addButtonLoaderSB").css("display", "none");
        $("#loaderSB").css("display", "block");

        let options = {
          method: "POST",
          // url: `${URL_BASE}/Api_SlineBillingSeaExport/addseaExportSlinePayment_multi.php`,
          //url: `${URL_BASE}/Api_SlineBillingCCExport/addFFseaExportSlinePayment_multi.php`,
           url: `${URL_BASE}/Api_SlineBillingCCExport/addFFseaExportSlinePayment_multi_refactored.php`,
          // url: `${URL_BASE}/Api_SlineBillingCCExport/addFFseaExportSlinePayment_multiDispute.php`,
          data: JSON.stringify(this.SBDetail),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              $("#loaderSB").css("display", "none");
              $("#addButtonLoaderSB").css("display", "block");

              // Backend validation failure (e.g. invoice no already exists) —
              // it returns HTTP 200 with an errorLogin field. Do not navigate away.
              if (data.errorLogin) {
                this.addSBDetail_button = false;
                this.alert.content = data.errorLogin;
                this.$refs["addPop"].open();
                return;
              }

              this.addSBDetail_button = false;
              window.history.go(-1);
              if (data.msg == "Inserted Successfully") {
                this.alert.content = "Data Added Successfully";
              } else {
                this.alert.content = "Data Updated Successfully";
                this.$refs["addPop"].open();
              }
            }
          })
          .catch((error) => {
            $("#loaderSB").css("display", "none");
            $("#addButtonLoaderSB").css("display", "block");
            this.addSBDetail_button = false;
            const resp = error && error.response && error.response.data;
            this.alert.content =
              (resp && (resp.errorLogin || resp.msg)) ||
              "Something went wrong while saving. Please try again.";
            this.$refs["addPop"].open();
          });
      }
    },

    containerNoRegexfun() {
      this.showAlgo = true;
      this.getConAlgoList();
      this.algoConNo = this.validContainerNo;
      // let lastDigitReturn = this.validContainerNo.slice(
      //   this.validContainerNo.length - 7
      // );
      // let lastDigitCon = this.ContainerTypeSizefactory.containerNo.slice(
      //   this.ContainerTypeSizefactory.containerNo.length - 7
      // );
      let containerformat = new RegExp("^[a-zA-Z]{4}[0-9]{7}$");
      let arrayLen = [];
      if (this.ContainerTypeSizefactory.ffExecutionContainerId == "") {
        arrayLen = this.containerTypeDetailFactoryList.filter((x) => {
          return x.containerNo == this.ContainerTypeSizefactory.containerNo;
        });
      }

      if (
        arrayLen.length > 0 &&
        this.ContainerTypeSizefactory.ffExecutionContainerId == ""
      ) {
        this.containerNoRegexError = "Already Exist";
      } else if (containerformat.test(this.ContainerTypeSizefactory.containerNo)) {
        this.containerNoRegexError = "";
      } else {
        this.containerNoRegexError = "Enter Valid Format";
      }
    },

    getFFSlinePaymentData(mainEnquiryId) {
      this.doLoading();
      this.FFSeaExportArr = [];

      let payload = {
        itemCode: "getFFSlinePaymentList",
        mainEnquiryId: mainEnquiryId,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Common/getDataCheck.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;

          console.log("hello salil", data);

          if (status == 200 && data) {
            if (data.FFSeaExportList.length > 0) {
              this.FFSeaExportArr = data.FFSeaExportList;
            }
          } else {
            this.FFSeaExportArr = [];
          }
          this.doLoadingClose();
        })

        .catch((error) => {
          console.log("Catch on FFSline Payment Data Error: ", error);
        });
    },

    getData() {
      this.doLoading();
      if (this.sbDetailArrayList.length == 1) {
        this.sbDetailArray = [];
      }
      if (this.containerTypeDetailFactory.length == 1) {
        this.containerTypeDetailFactory = [];
      }
      if (this.getContainerList.length == 1) {
        this.getContainerList = [];
      }
      let new_data = {
        ffExportFclId: this.$sessionsStorage.get("editExportFCLId"),
        ffBookingId:
          this.$sessionsStorage.get("editFFBookingId") != "" &&
            this.$sessionsStorage.get("editFFBookingId") != undefined
            ? this.$sessionsStorage.get("editFFBookingId")
            : "",
        allModuleId: this.$sessionsStorage.get("editSalesExId"),
      };
      this.SBDetail.allModuleId = this.$sessionsStorage.get("editSalesExId");
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_SlineBillingCCExport/viewFFEXPBookingDetails.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;

          if (status == 200 && data) {
            console.log("data=>", data);
            // alert(data.row_ffExecutionId.length)
            if (data.ContainerFromTPT.length > 0 || data.row_ffExecutionId.length > 0) {
              // alert(this.$sessionsStorage.get("editFFExecutionId"))
              if (
                this.$sessionsStorage.get("editFFExecutionId") != undefined ||
                this.$sessionsStorage.get("editFFExecutionId") != null ||
                this.$sessionsStorage.get("editFFExecutionId") != ""
              ) {
                this.$sessionsStorage.set("editFFExecutionId", data.autoExecutionId);
              }
              if (data.ContainerFromTPT.length > 0) {
                this.ContainerFromTPT = data.ContainerFromTPT;

                if (data.ContainerFromTPT[0].ContainerNumber != null) {
                  this.ContainerNoTPT = data.ContainerFromTPT[0].ContainerNumber.split(
                    ","
                  );
                }
                if (data.ContainerFromTPT[0].ContainerType.length > 0) {
                  this.ContainerNoTypeTPT = data.ContainerFromTPT[0].ContainerType.split(
                    ","
                  );
                }
                this.conDetailsTPT =
                  data.ContainerFromTPT[0].ContainerType +
                  "\n" +
                  data.ContainerFromTPT[0].ContainerNumber;
              }
            }

            this.getLocationList = data.portLocationArray;

            if (data.containerCountWise.length > 0) {
              this.containerCountWise = data.containerCountWise;
              let array_new = this.containerCountWise.map((x) => {
                if (x.totalCount == 0) {
                  this.showDivCountNote = false;
                } else {
                  this.showDivCountNote = true;
                  return false;
                }
              });
            }

            if (data.packageNameList.length > 0) {
              this.packageNameList = data.packageNameList;
            }

            if (data.containerMaster.length > 0) {
              this.getContainerList = data.containerMaster;
            }

            if (data.ffBookingDetail.length > 0) {
              Object.keys(data.ffBookingDetail[0]).map((x) => {
                this.BookingShippingLine[x] = data.ffBookingDetail[0][x] || "";
              });
            }

            if (data.editFFEX.length > 0) {
              console.log("editFFEX:", data.editFFEX);
              this.WarehouseStuffing.portType = data.editFFEX[0].portType;
              // this.SBDetail.allModuleId = data.editFFEX[0].allModuleId;
              this.POD = data.editFFEX[0].POD;

              this.ffExportDetail.oe_oceanf_rate = data.editFFEX[0].oe_oceanf_rate;
              if (data.editFFEX[0].oe_oceanf_rate) {
                this.ffExportDetail.disable_oe_oceanf_rate = true;
              }

              this.ffExportDetail.oe_oceanf_remark = data.editFFEX[0].oe_oceanf_remark;
              if (data.editFFEX[0].oe_oceanf_remark) {
                this.ffExportDetail.disable_oe_oceanf_remark = true;
              }
              if (data.editFFEX[0].blType) {
                this.SBDetail.blType = data.editFFEX[0].blType;
                this.SBDetail.blLandingId = data.editFFEX[0].blLandingId;
              }

              if (data.mainSalesData.length > 0) {
                this.sob_date_detected=data.mainSalesData[0].sob_date_detected;
                this.getFFSlinePaymentData(data.mainSalesData[0].mainEnquiryId);
              }

              if (
                data.editFFEX[0].container_count_arr != null &&
                data.editFFEX[0].container_count_arr != undefined &&
                data.editFFEX[0].container_count_arr != ""
              ) {
                // alert(data.editFFEX[0].container_count_arr);
                let oceanFreightDetails_Arr = JSON.parse(
                  data.editFFEX[0].container_count_arr
                );
                console.log(data.ContainerTypeList);
                // alert(oceanFreightDetails_Arr.length);

                if (
                  data.ContainerTypeList.length > 0 &&
                  oceanFreightDetails_Arr.length > 0 &&
                  data.CurrencyList.length > 0
                ) {
                  oceanFreightDetails_Arr.forEach((element1) => {
                    data.ContainerTypeList.forEach((element2) => {
                      data.CurrencyList.forEach((element3) => {
                        if (
                          element1.cont_type == element2.containerTypeId &&
                          element1.currency == element3.currency_id
                        ) {
                          let obj = {};
                          obj = {
                            cont_type_id: element2.containerTypeId,
                            cont_type: element2.containerType,
                            buying_ocean_freight: element1.buying_ocean_freight,
                            currencyName: element3.currencyCode,
                            currencyId: element3.currency_id,
                          };
                          this.oceanFreightDetails.push(obj);
                        }
                      });
                    });
                  });
                }
              }

              this.WarehouseStuffing.stuffingType = data.editFFEX[0].stuffingType;

              this.WarehouseStuffing.containerInfo = data.editFFEX[0].containerInfo;
              Object.keys(data.editFFEX[0]).map((x) => {
                this.ffExportDetail[x] = data.editFFEX[0][x] || "";
              });

              this.ffExportDetail.oe_fk_currency_id = data.editFFEX[0].oe_fk_currency_id
                ? data.editFFEX[0].oe_fk_currency_id
                : "1";
              if (data.editFFEX[0].oe_fk_currency_id) {
                this.ffExportDetail.disable_oe_fk_currency_id = true;
              }
            }

            if (data.ffBookingTranshipment.length > 0) {
              this.tentativeDetailArray = data.ffBookingTranshipment;
            }
            this.verifyJoBWiseContainer();
            // alert(this.$sessionsStorage.get("editFFExecutionId"))
            if (
              this.$sessionsStorage.get("editFFExecutionId") != "" &&
              this.$sessionsStorage.get("editFFExecutionId") != undefined
            ) {
              this.viewExecutionDetail();
            } else {
              this.doLoadingClose();
            }
            // this.JqueryFun();
          }
        })
        .catch((error) => { });
    },
    verifyJoBWiseContainer() {

      let payLoad = {
        module_type: "FF Export",
        allModuleId: this.ffExportDetail.allModuleId,
      };

      NodeLockPannelService.verifyContainer(payLoad)
        .then((response) => {
          const { data, status, statusText } = response;
          console.log("data getFailedSobCont PS=>", data);
          if (data.data.length > 0) {
            if (!data.data[0].subsFailedStatus) {
              this.getFailedSobCont = data.data[0].getFailedSobCont;
            }
          }

        })
        .catch((error) => {
          console.log("Catch on verifyJoBWiseContainer Error: ", error);
        });
    },
    viewExecutionDetail() {
      this.doLoading();
      // this.doLoadingClose();
      let new_data = {
        ffExportFclId: this.$sessionsStorage.get("editExportFCLId"),
        ffBookingId: this.$sessionsStorage.get("editFFBookingId"),
        ffExecutionId: this.$sessionsStorage.get("editFFExecutionId"),
        newData: this.ffExportDetail,
        allModuleId: this.$sessionsStorage.get("editSalesExId"),
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_SlineBillingCCExport/viewFFEXPExecutionDetailsMulti.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      // console.log("Execution");

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          // alert("happy")
          if (status == 200 && data) {
            // console.log("count => ", data.ffSLinePayDetail.length);
            console.log("data ffSLinePayDetail=> ", data);
            // console.log("ffSLinePayDetail => ", data.ffSLinePayDetail);
            if (data.ffSLinePayDetail.length > 0) {
              Object.keys(this.SBDetail).map((x) => {
                this.SBDetail[x] = data.ffSLinePayDetail[0][x] || "";
              });

              this.ffExportDetail.shippingID = this.SBDetail.shippingID;
              console.log("Shreshth Gahlot SBDetail => ", this.SBDetail);
              Object.keys(this.lineInvModalArray).map((x) => {
                this.lineInvModalArray[x] = data.ffSLinePayDetail[0][x] || "";
              });

              data.ffSLinePayDetail.forEach((element) => {
                // console.log("Element => ", element["invoiceAmount"]);

                let amount = element["invoiceAmount"]
                  ? element["invoiceAmount"].split(",")
                  : [];
                let currency = element["invoiceCurrency"]
                  ? element["invoiceCurrency"].split(",")
                  : [];

                element["invNo"] = element.ffSlineInvNo;
                element["inv_date"] = element.inv_date;
                element["invType"] = element.ffSlineInvType || [];
                element["invCategory"] = element.ffSlineInvCategory;
                element["scCategory"] = element.scCategory;
                element["scremark"] = element.scremark;
                element["dispute_status"] = element.dispute_status || "";
                element["sline_dispute"] = element.sline_dispute || "";
                element["resolved_amount"] = element.resolved_amount || "";

                // console.log(element["invNo"] + " : " + element["invType"]);

                let invCurrencyList = [];

                if (amount.length > 0) {
                  for (var i = 0; i < amount.length; i++) {
                    invCurrencyList.push({
                      invAmount: amount[i],
                      invCurrency: currency[i],
                    });
                  }
                }

                element["invCurrencyList"] = invCurrencyList;

                //this.lineInvModalArray.push(element)
              });

              data.ffSLinePayInvoices.forEach((element) => {
                console.log("Element  Jio => ", data.ffSLinePayInvoices);
                element["invNo"] = element.ffSlineInvNo;
                element["inv_date"] = element.inv_date;
                // element['invType'] =element.ffSlineInvType
                element["invType"] = element.ffSlineInvType ? JSON.parse(element.ffSlineInvType) : [];
                element["invCategory"] = element.ffSlineInvCategory;
                element["scCategory"] = element.scCategory;
                element["scremark"] = element.scremark;
                element["dispute_status"] = element.dispute_status || "";
                element["sline_dispute"] = element.sline_dispute || "";
                element["resolved_amount"] = element.resolved_amount || "";
                this.items = element.ffSlineInvType ? JSON.parse(element.ffSlineInvType) : [];

                var invoiceAmount = data.ffSLinePayAmount.filter((amoIndex) => {
                  return amoIndex.ffSlineInvId == element.ffSlineInvId;
                });

                let invCurrencyList = [];

                for (var i = 0; i < invoiceAmount.length; i++) {
                  invCurrencyList.push({
                    ffSlineInvAmoId: invoiceAmount[i].ffSlineInvAmoId,
                    invNo: invoiceAmount[i].ffSlineInvNo || "",
                    inv_date: invoiceAmount[i].inv_date || "",
                    invId: invoiceAmount[i].ffSlineInvId || "",
                    invPayId: invoiceAmount[i].ffSlinePayId || "",
                    invAmount: invoiceAmount[i].ffSlineInvAmount || "",
                    invCurrency: invoiceAmount[i].ffSlineInvCurrency || "",
                    invPayMode: invoiceAmount[i].ffSlineInvPayMode || "",
                    invPayRef: invoiceAmount[i].ffSlineInvPayRef || "",
                    invPaidAmount: invoiceAmount[i].ffSlineInvPaidAmount || "",
                    invPayDate: invoiceAmount[i].ffSlineInvPayDate || "",
                    invPayStatus: invoiceAmount[i].ffSlineInvPayStatus || "",
                  });
                }

                element["invCurrencyList"] = invCurrencyList;

                this.lineInvModalArray.push(element);
              });

              if (this.lineInvModalArray.length > 0) {
                this.onOceanFreightSelect();
              }

              // Priyanshu Singh Code Start

              const enptyarr = [];
              let arr1 = data.INVDoc;
              let arr2 = this.lineInvModalArray;
              console.log("INVDoc_query=>", data.INVDoc_query);
              console.log("arr1=>", arr1);
              console.log("arr2=>", arr2);

              // debugger;
              let result = [];
              arr1.forEach((ar, arr1index) => {
                result[arr1index] = Object.assign({}, arr1[arr1index], arr2[arr1index]);
              });
              // console.log("result=>", result);
              this.lineInvModalArray = [];
              this.$forceUpdate();
              result.forEach((element) => {
                if (element.ffSlineInvId != "") element["enableDisable"] = true;
                element["doc_id"] = element.doc_id;
                element["documentName"] = element.documentName;
                element["documentLink"] = element.documentLink;
                element["docRemarks"] = element.docRemarks;
                element["isDocActive"] = element.isDocActive;
                element["otherDocName"] = element.otherDocName;
                element["docAddedDate"] = element.docAddedDate;
                element["invNo"] = element.ffSlineInvNo;
                element["inv_date"] = element.inv_date;
                element["invType"] = element.ffSlineInvType ? JSON.parse(element.ffSlineInvType) : [];
                element["invCategory"] = element.ffSlineInvCategory;
                element["scCategory"] = element.scCategory;
                element["scremark"] = element.scremark;
                element["dispute_status"] = element.dispute_status || "";
                element["sline_dispute"] = element.sline_dispute || "";
                element["resolved_amount"] = element.resolved_amount || "";
                this.items = element.ffSlineInvType ? JSON.parse(element.ffSlineInvType) : [];

                var invoiceAmount = data.ffSLinePayAmount.filter((amoIndex) => {
                  return amoIndex.ffSlineInvId == element.ffSlineInvId;
                });

                let invCurrencyList = [];

                for (let i = 0; i < invoiceAmount.length; i++) {
                  let date = new Date(invoiceAmount[i].ffSlineInvPayDate);
                  let result =
                    "" +
                    date.getFullYear() +
                    (date.getMonth() + 1 > 9 ? "-" : "-0") +
                    (date.getMonth() + 1) +
                    (date.getDate() > 9 ? "-" : "-0") +
                    date.getDate();
                  // alert(result);
                  let ffSlineInvPayDate = "";
                  if (result == "1970-01-01") {
                    ffSlineInvPayDate = "";
                  } else {
                    ffSlineInvPayDate = result;
                  }
                  invCurrencyList.push({
                    ffSlineInvAmoId: invoiceAmount[i].ffSlineInvAmoId,
                    invNo: invoiceAmount[i].ffSlineInvNo || "",
                    inv_date: invoiceAmount[i].inv_date || "",
                    invId: invoiceAmount[i].ffSlineInvId || "",
                    invPayId: invoiceAmount[i].ffSlinePayId || "",
                    invAmount: invoiceAmount[i].ffSlineInvAmount || "",
                    invCurrency: invoiceAmount[i].ffSlineInvCurrency || "",
                    invPayMode: invoiceAmount[i].ffSlineInvPayMode || "",
                    invPayRef: invoiceAmount[i].ffSlineInvPayRef || "",
                    invPaidAmount: invoiceAmount[i].ffSlineInvPaidAmount || "",
                    invPayDate: ffSlineInvPayDate || "",
                    invPayStatus: invoiceAmount[i].ffSlineInvPayStatus || "",
                  });
                }
                element["invCurrencyList"] = invCurrencyList;

                this.lineInvModalArray.push(element);
              });
              this.$forceUpdate();
              // console.log(
              //   "this.NWQlineInvModalArray=>",
              //   this.lineInvModalArray
              // );
              if (result.length > 0) {
                this.disableSaveSubmit = true;
              }

              if (this.accounts == true || this.role == "Admin") {
                this.disableSaveSubmit = false;
              }
              // console.log("NewlineInvModalArray", this.lineInvModalArray);
              // console.log("SBDetails new => ", this.lineInvModalArray);

              // Priyanshu Singh Code End
            }

            // console.log("SBDetails new => ", this.lineInvModalArray);
            if (data.ffExecutionDetail.length > 0) {
              Object.keys(this.WarehouseStuffing).map((x) => {
                this.WarehouseStuffing[x] = data.ffExecutionDetail[0][x] || "";
              });
              this.SBDetail.sobDate = data.ffExecutionDetail[0]['sobDate'];
            }

            if (data.ffExecutionDetailContainer.length > 0) {
              if (this.ContainerFromTPT.length > 0) {
                let dummyContainer = [];
                for (let i = 0; i < data.ffExecutionDetailContainer.length; i++) {
                  let obj = {
                    ffExecutionContainerId:
                      data.ffExecutionDetailContainer[i].ffExecutionContainerId,
                    containerTypeId: data.ffExecutionDetailContainer[i].containerTypeId,
                    containerType: data.ffExecutionDetailContainer[i].containerType,
                    LineSealNo: data.ffExecutionDetailContainer[i].LineSealNo,
                    PickupLocation: data.ffExecutionDetailContainer[i].PickupLocation,
                    StuffingLocation: data.ffExecutionDetailContainer[i].StuffingLocation,
                    cargoStuffingDate:
                      data.ffExecutionDetailContainer[i].cargoStuffingDate,
                    cargoWeight: data.ffExecutionDetailContainer[i].cargoWeight,
                    containerInfo: data.ffExecutionDetailContainer[i].containerInfo,
                    containerWithSplit:
                      data.ffExecutionDetailContainer[i].containerWithSplit,
                    customSealNo: data.ffExecutionDetailContainer[i].customSealNo,
                    ffExecutionId: data.ffExecutionDetailContainer[i].ffExecutionId,
                    ffExportFclId: data.ffExecutionDetailContainer[i].ffExportFclId,
                    grossWeight: data.ffExecutionDetailContainer[i].grossWeight,
                    handoverDate: data.ffExecutionDetailContainer[i].handoverDate,
                    leeoDate: data.ffExecutionDetailContainer[i].leeoDate,
                    leeoNo: data.ffExecutionDetailContainer[i].leeoNo,
                    measurement: data.ffExecutionDetailContainer[i].measurement,
                    netWeight: data.ffExecutionDetailContainer[i].netWeight,
                    noOfpkgUnit: data.ffExecutionDetailContainer[i].noOfpkgUnit,
                    packageId: data.ffExecutionDetailContainer[i].packageId,
                    pickupDate: data.ffExecutionDetailContainer[i].pickupDate,
                    portType: data.ffExecutionDetailContainer[i].portType,
                    stuffingDate: data.ffExecutionDetailContainer[i].stuffingDate,
                    tareWeight: data.ffExecutionDetailContainer[i].tareWeight,
                    weightUnit: data.ffExecutionDetailContainer[i].weightUnit,
                    containerNo:
                      data.ffExecutionDetailContainer[i].containerNo == ""
                        ? this.ContainerNoTPT[i]
                        : data.ffExecutionDetailContainer[i].containerNo,
                  };
                  dummyContainer.push(obj);
                }
                this.containerTypeDetailFactory = dummyContainer;
              } else {
                this.containerTypeDetailFactory = data.ffExecutionDetailContainer;
              }

              Object.keys(this.ContainerTypeSizefactory).map((x) => {
                this.ContainerTypeSizefactory[x] =
                  data.ffExecutionDetailContainer[0][x] || "";
              });

              Object.keys(this.removeContainerVmodel).map((x) => {
                this.ContainerTypeSizefactory[x] = "";
              });
            }

            if (data.ffSBDetail.length > 0) {
              this.sbDetailArray = data.ffSBDetail;
            }
            if (data.suplimentaryInvData.length > 0) {
              this.suplimentaryInvData = data.suplimentaryInvData;
            }

            if(data.ffSLinePayDetail.length>0){
            this.SBDetail.sobDate=data.ffSLinePayDetail[0].sobDate;
            }

            const user_data = {
              userId: this.ffExportDetail.userId,
            };
            let options = {
              method: "POST",
              url: `${URL_BASE}/getUser.php`,
              data: JSON.stringify(user_data),
              crossDomain: true,

              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: this.$sessionsStorage.get("loginId"),
              },
            };

            axios(options).then((result2) => {
              const { statusText, status, data } = result2;
              // console.log(data);
              if (data.user) {
                // console.log(data);
                this.ffExportDetail.username = data.user[0].employeeName;
              }
            });
            this.doLoadingClose();
          }
        })
        .catch((error) => { });
    },

    getForwarderName(forwarderId){
      let forwarder = this.$store.getters['common/getAllClientList'].filter((x) => {
          if (x.clientId == forwarderId) {
            return (x.clientName);
          }
        });
        if(forwarder.length>0){
        this.SBDetail.forwarderName=forwarder[0].clientName;
        console.log('forwarder=>',forwarder);
        }
    },

    CheckShippingLine(shippingLine, shippingID) {
      let newSlne = "";
      // alert(this.ffExportDetail.containerInfo);

      if (this.ffExportDetail.containerInfo == "lcl") {
        let arrayFilter = this.$store.getters["common/getAllColoaderList"].filter((x) => {
          if (x.shippingId == shippingID) {
            return (newSlne = x.shippingLine);
          }
        });
      } else {
        let arrayFilter = this.$store.getters["common/getAllShippingLineList"].filter(
          (x) => {
            if (x.shippingId == shippingID) {
              return (newSlne = x.shippingLine);
            }
          }
        );
      }
      if (shippingLine != newSlne) {
        $("#ShippingIdError").html(
          '<span style="color:red;">Shipping Mismatch !! Cannot be processed, Please contact admin.</span>'
        );
        this.alert.content = "Shipping Mismatch !!";
        this.$refs["addPop"].open();
        return false;
      } else {
        $("#ShippingIdError").hide();
      }
      // if (shippingLine != newSlne) {
      //   this.alert.content = "Shipping Mismatch !!";
      //   this.$refs["addPop"].open();
      //   return false;
      // }
    },
  },
  created() {
    eventBus.$on("fileuploaded", (file) => {
      console.log("PS=>", file);
      this.fileType = "";
      this.fileUrl = "";
      this.SBDetail.slineInvoice = file.url;
      if (file.folderName == "BL_DRAFT") {
        this.fileType = file.folderName;
        this.SBDetail.blDraftUpload = "";
        this.SBDetail.blDraftUpload = file.url;
        this.fileUrl = file.url;
      } else if (file.folderName == "Sline_Invoice") {
        this.fileType = file.folderName;
        this.fileUrl = file.url;
      }
    });
    eventBus.$on("fileuploadedsecondindex", (indexObj) => {
      console.log("fileuploadedsecondindex=>", indexObj);
      if (this.fileType == "BL_DRAFT") {
        return;
      }
      const row = this.lineInvModalArray[indexObj.second_index];
      if (!row) {
        return;
      }
      row.invSlineUpload = this.fileUrl;
    });
  },
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}

.error {
  color: red;
}

@media only screen and (min-width: 320px) and (max-width: 767px) {
  .navbar-dark .navbar-brand.mobile-font {
    font-size: 15px !important;
  }
}
</style>



// WEBPACK FOOTER //
// ffSLinePaymentExportN_VP.vue?1369df86